export default {
  common: {
    appName: "دۇكانچى سېستىمىسى",
    appNameQrcode: "ئىككىلىك كود پائالىيەت سىستېمىسى",
    example: "مەسلەن",
    mobile: "يانفۇن",
    cancelText: "قالدۇرۇش",
    delete: "ئۆچۈرۈش",
    developingFeature: "بۇ ئىقتىدار تېخى ئېچىلىۋاتىدۇ ...",
    yuan: "يۈەن",
    minute: "مىنۇت",
    dayUnit: "كۈن",
    delete: "ئۆچۈرۈش",
    day: {
      1: "دۈ",
      2: "سە",
      3: "چا",
      4: "پە",
      5: "جۈ",
      6: "شە",
      7: "يە",
    },
    home: "باش بەت",
    search: "ئىزدەش",
    statusLabel: "ھالىتى",
    refresh: "يېڭىلاش",
    more: "تېخىمۇ كۆپ",
    richTextPlaceHolder: "مەزمۇننى كىرگۈزۈڭ",
    orderDescription: "سان قانچە چوڭ بولسا شۇنچە ئالدىغا تىزىلسا",
    independentCommissionDescription:
      "ئايرىم پىرسەنت بېكىتىلسە، سىستىما ئايرىم پىرسەنت بويىچە بىر تەرەپ قىلىدۇ، ۋاكالەتچى دەرىجىسىدىكى پىرسەنت ئويلىشىلمايدۇ.",
    yes: "ھەئە",
    no: "ياق",
    inactive: "ئاكتىپلانمىغان",
    active: "ئاكتىپلانغان",
    save: "ساقلاش",
    saveSuccess: "ساقلاندى",
  },
  base: {
    deliveryman: "توشۇغۇچى:",
    modal: {
      successTitle: "مەشغۇلات مۇۋەپپەقىيەتلىك بولدى",
      errorTitle: "مەشغۇلات مەغلۇپ بولدى",
      warningTitle: "ئاگاھلاندۇرۇش",
      infoTitle: "ئەسكەرتىش",
      confirmTitle: "مەشغۇلاتىڭىزنى راستىنلا داۋاملاشتۇرامسىز ؟",
      knowText: "بىلدىم",
      okText: "ھەئە",
      cancelText: "ياق",
    },
    api: {
      err401:
        "سىزنىڭ ئەزا ئۇچۇرىڭىزنىڭ ۋاقتى ئۆتۈپ كېتىپتۇ، بۇندىن كىيىنكى مەشغۇلاتلىرىڭىزنىڭ نورمال" +
        " داۋاملىشىشى ئۈچۈن قايتىدىن كىرىپ ئۇچۇرىڭىزنى يېڭىلىۋېلىڭ",
      err408:
        "ئۇچۇر ئېلىش ۋاقتى چەكتىن ئېشىپ كەتتى، مەشغۇلاتىڭىزنى قايتىلاپ ياكى بەتنى يېڭىلاپ سىناپ بېقىڭ",
      err422Title: "تەمىنلىگەن ئۇچۇرىڭىز تەلەپكە ئۇيغۇن ئەمەس",
      err422Empty:
        "تەمىنلىگەن ئۇچۇرىڭىز تەلەپكە ئۇيغۇن ئەمەس، ئۇچۇرلىرىڭىزنى تەپسىلي تەكشۈرگەندىن كىيىن سىناپ بېقىڭ",
      err429:
        "مەشغۇلاتىڭىز بەك تېز بولۇپ كەتتى، بىر ئاز ئارام ئېلىۋېلىپ ئاندىن داۋاملاشتۇرۇڭ",
      err500: "مۇلازىمېتىردا مەسىلە كۆرۈلدى، قايتا سىناپ بېقىڭ",
      err503: "مۇلازىمېتىردا مەسىلە كۆرۈلدى، قايتا سىناپ بېقىڭ",
      errUnknown:
        "نامەلۇم خاتالىق يۈز بەردى، مەشغۇلاتىڭىزنى قايتىلاپ ياكى بەتنى يېڭىلاپ سىناپ بېقىڭ",
    },
  },
  notFound: {
    backToHome: "باش بەتكە قايتىش",
    backToPrev: "ئالدىنقى بەتكە قايتىش",
    refresh: "بەتنى يېڭىلاش",
  },
  login: {
    titleImage: "/assets/images/login-title-ug.png",
    phoneHint: "تېلېفون نومۇرىڭىز",
    phoneHintRequired: "تېلېفون نومۇرىڭىز قۇرۇق قالمىسۇن",
    phoneHintPrefix: "تېلېفون نومۇرىڭىز چوقۇم 1 بىلەن باشلانسۇن",
    phoneHintCount: "تېلېفون نومۇرىڭىز چوقۇم 11 خانلىق بولسۇن",
    parolHint: "پارولىڭىز",
    parolHintRequired: "پارولىڭىز قۇرۇق قالمىسۇن",
    parolHintMin: "پارولىڭىز 6 خانىدىن كەم بولمىسۇن",
    parolHintMax: "پارولىڭىز 16 خانىدىن كۆپ بولمىسۇن",
    login: "كىرىش",
    loggingin: "كىرىۋاتىدۇ ...",
    loginSuccess: "كىرىش مۇۋەپپەقىيەتلىك بولدى",
    title: "بۇلۇت بازار سودىگەر سۇپۇسى",
    selectShop: "دۇكان تاللاڭ",
    enter: "كىرىش",
    insertShopName: "دۇكان نامىنى كىرگۈزۈڭ",
    password: "مەخپى نومۇر",
    reset: "مەخپى نومۇر ئۆزگەرتىش",
    pass: "يېڭى مەخپى نومۇر",
    passAgain: "قايتا كىرگۈزۈڭ",
    notMatch: "ئىككى قېتىم كىگۈزگەن مەخپى نومۇر بىردەك ئەمەس",
    forget: "ئۇنتۇپ قاپتىمەن",
    codeHint: "تەستىق كودىنى كىرگۈزۈڭ",
    getCode: "تەستق كود",
  },
  home: {
    chartTime: {
      week: "7 كۈن",
      month: "30 كۈن",
      season: "90 كۈن",
    },
    loadingData: "ئىستاتىستىكا ئۇچۇرنى ئېلىۋاتىدۇ ...",
    loadingDataWarning:
      "ئىستاتىستىكا ئۇچۇرنى ئېلىۋاتىدۇ، بىر ئازدىن كىيىن سىناڭ",
    numbers: {
      qrcode: "ئەپچاق ئىككىلىك كودى",
      dailyOrderCount: "بۈگۈنكى ئۈنۈملۈك زاكاز سانى",
      dailyOrderCountUnit: "تال",
      yesterdayOrderCount: "تۈنۈگۈن %{count} تال",
      dailyOrderIncome: "بۈگۈنكى زاكاز كىرىم سوممىسى",
      yesterdayOrderIncome: "تۈنۈگۈن %{income} يۈەن",
      dailyOrderTurnover: "بۈگۈنكى سودا سوممىسى",
      yesterdayOrderTurnover: "تۈنۈگۈن %{income} يۈەن",
      monthlyOrderCount: "بۇ ئايلىق ئۈنۈملۈك زاكاز سانى",
      monthlyOrderCountUnit: "تال",
      prevMonthOrderCount: "ئالدىنقى ئايدا %{count} تال",
      monthlyOrderIncome: "بۇ ئايلىق زاكاز كىرىم سوممىسى",
      prevMonthOrderIncome: "ئالدىنقى ئايدا %{income} يۈەن",
    },
    chart: {
      countTitle: "زاكاز سانى يۈزلىنىشى",
      dateAlias: "چېسىلا",
      countAlias: "زاكاز سانى",
      incomeTitle: "زاكاز سوممىسى يۈزلىنىشى",
      incomeAlias: "زاكاز سوممىسى",
    },
  },
  homeProductGroups: {
    addGroup: "گۇرۇپپا قوشۇش",
    editGroup: "گۇرۇپپانى تەھرىرلەش",
    groupTitle: "گۇرۇپپا ماۋزۇسى",
    titleImage: "بۆلەك ماۋزۇ سۈرىتى",
    listType: "كۆرسىتىش ئۇسۇلى",
    onePerRow: "بىر قۇردا بىر دانە",
    twoPerRow: "بىر قۇردا ئىككى دانە",
    threePerRow: "بىر قۇردا ئۈچ دانە",
    products: "مەھسۇلات تىزىملىكى",
    addProduct: "مەھسۇلات قوشۇش",
    productId: "مەھسۇلات نومۇرى",
    productCount: "مەھسۇلات سانى",
    productCountValue: "%{count} مەھسۇلات",
    moreProducts: "+%{count}",
    maxGroupsError: "ئەڭ كۆپ 20 گۇرۇپپا قوشۇلالايدۇ",
    maxItemsError: "ھەر گۇرۇپپىدا ئەڭ كۆپ 50 مەھسۇلات",
    itemsRequired: "كەم دېگەندە بىر مەھسۇلات قوشۇڭ",
    saveSuccess: "ساقلاندى",
    addSelectedCount: "تاللانغاننى قوشۇش (%{count})",
    selectAtLeastOne: "كەم دېگەندە بىر مەھسۇلات تاللاڭ",
    alreadyAdded: "قوشۇلغان",
    flashSaleType: "ۋاقىتلىق ئېتىبار گۇرۇپپىسى",
    flashSaleHint: "ئېچىلسا نۆۋەتتىكى ۋاقىتلىق ئېتىبار مەھسۇلاتلىرى ئاپتوماتىك كۆرۈنىدۇ، قولدا قوشۇش ھاجەتسىز",
    flashSaleAutoProducts: "مەھسۇلاتلار «سېتىش باشقۇرۇش → ۋاقىتلىق ئېتىبار» دىن كېلىدۇ",
    flashSaleBadge: "ۋاقىتلىق ئېتىبار",
    pageTitle: "باش بەت مەھسۇلات گۇرۇپپىسى",
    pageHint: "كىچىك پروگرامما باش بېتىدە تەرتىپ بويىچە كۆرۈنىدۇ. ماۋزۇ رەسىمى، ئورۇنلاشتۇرۇش ياكى ۋاقىتلىق ئېتىبارنى تەڭشىيەلەيسىز.",
    groupCount: "%{count} / %{max}",
    empty: "گۇرۇپپا يوق، ئوڭ ئۈستىدىن قوشۇڭ",
    basicInfo: "ئاساسىي ئۇچۇر",
    titleImages: "ماۋزۇ رەسىمى (ئىختىيارىي)",
    displaySettings: "كۆرسىتىش تەڭشىكى",
    selectedProducts: "تاللانغان مەھسۇلات",
  },
  main: {
    sideMenus: {
      home: "باش بەت",
      statistics: "سانلىق مەلۇمات",
      statisticsOverview: "ئومۇمىي ئەھۋال",
      statisticsOrders: "زاكاز ستاتىستىكىسى",
      statisticsProducts: "مەھسۇلات ستاتىستىكىسى",
      statisticsCommissions: "كومىسسىيە ستاتىستىكىسى",
      statisticsTransfers: "پۇل يۆتكەش ستاتىستىكىسى",
      delivery: "توشۇش باشقۇرۇش",
      order: "زاكاز باشقۇرۇش",
      orderList: "زاكازلار تىزىملىكى",
      printTemplates: "بېسىش قېلىپى",
      refundList: "پۇل قايتۇرۇش تىزىملىكى",
      downloadList: "جەدۋەل چۈشۈرۈش",
      import: "جەدۋەل كىرگۈزۈش",
      product: "مەھسۇلات باشقۇرۇش",
      productList: "مەھسۇلات تىزىملىكى",
      productImport: "مەھسۇلات كىرگۈزۈش",
      productUnits: "بىرلىك باشقۇرۇش",
      manageAds: "ئېلان باشقۇرۇش",
      sales: "تىجارەت",
      coupons: "ئېتىبار كارتىسى",
      holiday: "پائالىيەت",
      flash: "ۋاقىتلىق ئېتىبار",
      gift: "سوۋغات باشقۇرۇش",
      groupon: "تالىشىپ سېتىۋىلىش",
      ads: "سىيرىلما ئىلان",
      navs: "باش بەت سەھىپىسى",
      popups: "سەكلەپ چىقىدىغان ئىلان",
      splash: "ئېچىلىش ئىلانى",
      homeAd: "باش بەت ئىلانى",
      homeProductGroups: "باش بەت مەھسۇلات گۇرۇپپىسى",
      userCenterAd: "ئەزا مەركىزى ئىلانى",
      becomeAgentAd: "ھەمكارلاشقۇچىلار مەركىزى ئىلانى",
      mini: "ئەپچاق",
      miniSetting: "تەڭشىكى",
      merchantSetting: "دۇكان تەڭشىكى",
      wechatMerchantApplymentInfo: "ئۈندىدار دۇكاندار ئىلتىماس ئەھۋالى",
      serviceArea: "مۇلازىمەت رايونى",
      serviceAreaSetting: "رايون باشقۇرۇش",
      review: "باھا باشقۇرۇش",
      reviewList: "باھالار تىزىملىكى",
      finance: "مالىيە باشقۇرۇش",
      financeHome: "مالىيە باش بېتى",
      financeCheck: "ھېسابات تەكشۈرۈش",
      financeAccount: "ئاكونت باشقۇرۇش",
      financeDownload: "چۈشۈرۈش رايونى",
      promotion: "پائالىيەت باشقۇرۇش",
      promotionShop: "دۇكان پائالىيىتى",
      proxy: "ۋاكالەتچى باشقۇرۇش",
      proxyList: "ۋاكالەتچىلەر تىزىملىكى",
      agentRecommenderList: "تەۋسىيە مۇناسىۋىتى",
      agentLevel: "ۋاكالەتچى دەرىجىسى",
      agentLevelProduct: "ۋاكالەتچى دەرىجە مەھسۇلاتى",
      commissionList: "پايدا تىزىملىكى",
      withdrawList: "نەقلەش خاتىرىسى",
      withdrawRequestList: "نەقلەش ئىلتىماس خاتىرىسى",
      withdrawCommissionList: "پايدا ئايرىش تىزىملىكى",
      sendMoney: "پۇل ئۇرۇش خاتىرىسى",
      specialShareList: "ئالاھىدە مۇلازىمەت ھەققى",
      transferAccountList: "پۇل ئۇرۇش ھېساباتى",
      wechatRedPacketTopup: "قىزىل بولاق تولۇقلاش خاتىرىسى",
      balanceVipOrders: "VIP سېتىۋېلىش زاكازلىرى",
      users: "ئەزا باشقۇرۇش",
      usersList: "ئەزا تىزىملىكى",
      storeMemberships: "دۇكان تەكشۈرۈش",
      storeMembershipAttribution: "خېرىدار تەۋەلىك ئىستاتىستىكا",
      balance: "قالدۇق خاتىرىسى",
      topup: "پۇل تولۇقلاش خاتىرىسى",
      spend: "خەجلەش خاتىرىسى",
      reduce: "ئازلىتىش تارىخى",
      balanceUserList: "ئەزا تىزىملىكى(قالدۇقى بار)",
      shows: "دام-دام",
      showsList: "بارلىق",
      setting: "تەڭشەكلەر",
      settingShop: "دۇكان تەڭشەكلىرى",
      merchantStaff: "خادىم باشقۇرۇش",
      selectLang: "تىل تاللاش",
      live: "نەق مەيداق",
      liveList: "تىزىملىكى",
      lottery: "مۇكاپات باشقۇرۇش",
      lotteryList: "مۇكاپات خاتىرىسى",
      lotteryTheme: "مۇكاپات ئۇسلۇبى",
      redPacket: "قىزىل بولاق",
      article: "ماقالە باشقۇرۇش",
      articleList: "ماقالە تىزىملىكى",
      articleTags: "بەلگە باشقۇرۇش",
      articleEditorsChoice: "بۈگۈنلۈك سۆز",
      lotteryEdit: "مۇكاپات تەھرىرلەش",
      manageWeapp: "ئەپچاق باشقۇرۇش",
      members: "ئالىي ئەزا",
      membersList: "تىزىملىك",
      membersCard: "ئەزالىق كارتىسى",
      membersOrder: "ئەزالىق زاكاسلار",
      membersGiftCodes: "سوۋغات كودى پائالىيىتى",
      taskCenter: "ۋەزىپە مەركىزى",
      media: "ھۆججەت باشقۇرۇش",
      mediaList: "ھۆججەت تىزىملىكى",
      storageSetting: "ساقلاش تەڭشىكى",
      tuangouShop: "دۇكان",
      adminSection: "باشقۇرۇش بۆلىكى",
      orderDebug: "زاكاز تەكشۈرۈش",
      profitSharingReconciliation: "پايدا ئايرىش كۈتۈش تەكشۈرۈش",
      weapp: "ئەپچاق باشقۇرۇش",
    },
    userMenu: {
      loginMobile: "كىرگەن يانفون",
      ownerMobile: "دۇكان ھېسابات يانفونى",
      endDate: "مۇلازىمەت توشۇش ۋاقتى",
      logout: "چېكىنىش",
    },
    statusMenu: {
      business: "تىجارەت باشلاش",
      noBusiness: "دۇكان تاقاش",
      statusBusiness: "تىجارەت قىلىۋاتىدۇ ...",
      statusNoBusiness: "تاقىلىپ بولدى",
    },
    search: "ئىزدەش",
    searchHint: "زاكاز نومۇرى، زاكاز تەرتىپى، تېلېفون نومۇرنى كىرگۈزۈڭ",
    alreadyInBusiness: "دۇكان تىجارەت قىلىۋاتىدۇ، ئۆزگەرتىش ھاجەتسىز",
    alreadyNoBusiness: "دۇكان تاقىلىپ بولدى، ئۆزگەرتىش ھاجەتسىز",
    updatingBusinessStatus: "دۇكاننىڭ تىجارەت ھالىتى يېڭىلىنىۋاتىدۇ ...",
    updateBusinessStatusSuccess:
      "دۇكاننىڭ تىجارەت ھالىتى مۇۋەپپەقىيەتلىك يېڭىلاندى",
    noPermission: "كەچۈرۈڭ، سىزنىڭ بۇ رايونغا ھوقۇقىڭىز يەتمەيدۇ",
  },
  order: {
    eat: "مۇشۇ يەردە يەيدۇ",
    take: "ئەكىتىدۇ",
    print: "پىرىنتېردا بېسىش",
    new: "يېڭى زاكاس بايقالدى",
    newDesc: "يېڭى زاكاس بايقالدى، تىېز بىر تەرەپ قىلىڭ",
    printView: {
      price: "يەككە باھاسى",
      total: "جەمئىي",
      amount: "سانى",
    },
    printTemplate: {
      search: "قېلىپ ئىزدەش...",
      create: "يېڭى قېلىپ",
      createA4: "A4 قېلىپ قۇرۇش",
      create80: "80mm قېلىپ قۇرۇش",
      desktopNewPrint: "كومپىيۇتېر يېڭى بېسىش",
      mobileNewPrint: "يانفون يېڭى بېسىش",
      salesOrderTemplates: "سېتىش تالونى قېلىپى",
      usingNewBoth: "كومپىيۇتېر ۋە يانفون يېڭى بېسىشنى ئىشلىتىدۇ",
      manageHint: "زاكاز بېسىش قېلىپىنى باشقۇرۇش",
      templatesUnit: "قېلىپ",
      updated: "يېڭىلانغان",
      copies: "نۇسخا",
      desktopDefault: "كومپىيۇتېر سۈكۈت",
      settings: "تەڭشەك",
      design: "لايىھە",
      copy: "كۆچۈرۈش",
      delete: "ئۆچۈرۈش",
      desktopEnabled: "كومپىيۇتېر",
      mobileEnabled: "يانفون",
      setDesktopDefault: "كومپىيۇتېر سۈكۈت قىلىش",
      deleteConfirm: "بۇ قېلىپنى ئۆچۈرەمسىز؟",
      deleted: "ئۆچۈرۈلدى",
      duplicated: "كۆچۈرۈلدى",
      a4Custom: "A4 ئىختىيارىي قېلىپ",
      mmBasic: "%{size} ئاساسىي قېلىپ",
      defaultA4Name: "سېتىش تالونى A4",
      default80Name: "سېتىش تالونى 80mm",
      salesOrder: "سېتىش تالونى",
      insertComponents: "قىسم قوشۇش",
      outline: "قىسم تىزىملىكى",
      rowContainer: "قۇر قاچىسى",
      itemsUnit: "دانە",
      sideStack: "يان تەرەپ",
      besideRows: "يان قۇر سانى",
      besideRowsHint:
        "N قىلسىڭىز پەقەت N دانە بىرىكمە QR يېنىدا تۇرىدۇ، قالغانلىرى ئاستىدا پۈتۈن قۇر بولىدۇ. 0 بولسا ياندا تۇرمايدۇ.",
      ejectFromBeside: "ياندىن چىقىرىش",
      ejectFromBesideHint:
        "باشقا قىسىمغا سۆرەپ چىقارسىڭىزمۇ بولىدۇ، ياكى ئوڭ ئۈستىدىكى چىقىش كۇنۇپكىسىنى بېسىڭ.",
      joinBeside: "يانغا قايتۇرۇش",
      dragToReorder: "سۆرەپ تەرتىپلەش",
      moveUp: "ئۈستىگە",
      moveDown: "ئاستىغا",
      props: "خاسلىق تەڭشىكى",
      selectComponent: "بىر قىسم تاللاڭ",
      positionSize: "ئورۇن ۋە چوڭلۇق",
      startCol: "باشلىنىش ستونى",
      span: "ستون سانى",
      marginTop: "ئۈستى ئارىلىق",
      textContent: "تېكىست",
      showLabel: "بەلگە كۆرسىتىش",
      labelText: "بەلگە تېكىستى",
      fontSize: "خەت چوڭلۇقى",
      bold: "توم",
      align: "توغرىلاش",
      alignLeft: "سول",
      alignCenter: "ئوتتۇرا",
      alignRight: "ئوڭ",
      templateLang: "قېلىپ تىلى",
      chooseTemplate: "قېلىپ تاللاش",
      langZh: "خەنزۇچە",
      langUg: "ئۇيغۇرچە",
      tableType: "جەدۋەل تىپى",
      showHeader: "جەدۋەل بېشى",
      tableBorder: "جەدۋەل رامكىسى",
      borderNone: "رامكىسىز",
      borderFull: "تولۇق رامكا",
      summaryRow: "جەملىمە قۇر",
      showSummary: "جەملىمە كۆرسىتىش",
      summaryLabel: "جەملىمە بەلگىسى",
      summaryColumns: "جەملىمە ستونى",
      headerRow: "بېشى قۇر",
      bodyRow: "مەزمۇن قۇر",
      columnConfig: "ستون تەڭشىكى",
      addColumn: "ستون قوشۇش",
      imageUrl: "رەسىم ئادرېسى",
      height: "ئېگىزلىك",
      customValue: "ئىختىيارىي مەزمۇن",
      qrSize: "QR چوڭلۇقى",
      barcodeFormat: "تىزىملىك كود تىپى",
      barcodeFormatQr: "ئىككى ئۆلچەملىك كود (ئۈندىدار)",
      barcodeFormatCode128: "بىر ئۆلچەملىك Code128",
      preview: "كۆرۈش",
      save: "ساقلاش",
      saved: "ساقلاندى",
      exit: "چېكىنىش",
      exitConfirm: "لايىھەدىن چېكىنەمسىز؟ ساقلانمىغان ئۆزگىرىشلەر يوقىلىدۇ.",
      notFound: "قېلىپ تېپىلمىدى",
      backToList: "تىزىملىككە قايتىش",
      emptyCanvas: "سول تەرەپتىن قىسم قوشۇپ باشلاڭ",
      groups: {
        text: "تېكىست",
        qrcode: "QR كود",
        image: "رەسىم",
        barcode: "تىزىملىك كود",
        products: "مەھسۇلات تەپسىلاتى",
        other: "باشقىلار",
      },
      comps: {
        customText: "ئىختىيارىي تېكىست",
        customerName: "خېرىدار ئىسمى",
        orderNotes: "ئىزاھات",
        merchantName: "دۇكان ئىسمى",
        merchantTel: "دۇكان تېلېفونى",
        orderTime: "زاكاز ۋاقتى",
        printTime: "بېسىش ۋاقتى",
        orderNo: "زاكاز نومۇرى",
        address: "ئادرېس",
        customerTel: "خېرىدار تېلېفونى",
        payType: "تۆلەش ئۇسۇلى",
        shipPrice: "توشۇش ھەققى",
        totalAmount: "جەمئىي سومما",
        orderQr: "زاكاز كىچىك پروگرامما كودى",
        customQr: "ئىختىيارىي QR",
        logo: "لوگو",
        customImage: "ئىختىيارىي رەسىم",
        orderBarcode: "نومۇر كودى",
        customBarcode: "ئىختىيارىي كود",
        productLines: "مەھسۇلات تىزىملىكى",
        productSummary: "مەھسۇلات جەملىمىسى",
        divider: "ئايرىش سىزىقى",
        spacer: "بوشلۇق",
      },
      cols: {
        index: "تەرتىپ",
        image: "رەسىم",
        name: "مەھسۇلات",
        sku: "ئۆلچەم",
        nameSku: "مەھسۇلات/ئۆلچەم",
        barcode: "تاياق كود",
        unit: "بىرلىك",
        amount: "سانى",
        price: "باھا",
        lineTotal: "سومما",
        remark: "ئىزاھات",
      },
    },
    isFromBB: "بۇلۇت بازاردىن كەلگەن",
    isDouyin: "دوۋيىن",
    payTypes: {
      all: "ھەممىسى",
      wechat: "ئۈندىدار",
      cash: "نەق پۇل",
      balance: "قالدۇق",
    },
    orderTypes: {
      all: "ھەممىسى",
      valid: "ئۈنۈملۈك",
      invalid: "قالدۇرۇلغان",
      unsend: "مال سېلىنمىغان",
      waiting: "بىر تەرەپ قىلمىغان",
      sent: "مال سېلىنغان",
      delivered: "تاپشۇرىۋالغان",
      completed: "تاماملانغان",
      applied: "ئىلتىماس قىلىنغان",
    },
    refundTypes: {
      all: "ھەممىسى",
      inProgress: "بىر تەرەپ قىلىنىۋاتقان",
      waiting: "بىر تەرەپ قىلمىغان",
      accepted: "تەستىقلانغان",
      refunding: "قايتۇرىلىۋاتقان",
      refunded: "قايتۇرۇلغان",
      refused: "رەت قىلىنغان",
      failed: "بىر تەرەپ قىلمىغان",
    },
    sortTypes: {
      created_at_desc: "يېڭىسى ئالدىدا",
      created_at_asc: "كونىسى ئالدىدا",
      sequence: "زاكاز تەرتىپى",
    },
    loadingData: "زاكاز تىزىملىكى يۈكلىنىۋاتىدۇ ...",
    printingOrder: "زاكاز ئۇرۇلىۋاتىدۇ...",
    updatingData: "زاكاز تىزىملىكى يېڭىلىنىۋاتىدۇ ...",
    payTypesTitle: "پۇل تۆلەش شەكلى",
    finishProfitSharing: "زاكازنى ئاخىرلاشتۇرۇش",
    orderTypesTitle: `زاكاز         ھالىتى`,
    sortTypesTitle: "زاكاز     تىزىلىشى",
    rangeTimeTitle: "زاكاز          ۋاقتى",
    ordersTitle: "زاكازلار تىزىملىكى",
    ordersTitleCount: "جەمئىي %{total} تال زاكاز",
    loadingOrder: "زاكازلار تىزىملىكى يۈكلىنىۋاتىدۇ ...",
    loadingOrderEmpty: "مۇناسىۋەتلىك زاكاز تېپىلمىدى",
    todaysTitle: " زاكاز ئەھۋالى",
    detailStatisticsTitle: " مال ئەھۋالى",
    todaysLoading: "ئۇچۇر ئېلىۋاتىدۇ ...",
    todaysEmpty: "ھازىرچە ئۇچۇر يوق",
    todaysCount: "زاكاز : %{orderCount} تال",
    todaysTotal: "زاكاز ئۇمۇمي سوممىسى : %{totalPrice} يۈەن",
    productInfo: "مەھسۇلات ئۇچۇرى",
    productInfoCollapse: "يىغىش",
    productInfoExpand: "ئېچىش",
    note: "خېرىدار ئەسكەرتىشى：",
    noteUser: "[تەلەپ - تەغدىم] %{note}؛",
    noteNo: "ئالاھىدە تەلەپ يوق",
    tablewareCount: "[چوكا - قوشۇق] %{count}؛",
    tablewareNo: "ئۆزى تەييارلايدۇ",
    tablewarePeople: "%{count} ئادەم",
    packingFee: "ئوراش ھەققى",
    giftLabel: "سوۋغات:",
    shippingFee: "توشۇش ھەققى",
    subTotal: "جەمئىي",
    merchantExpence: "دۇكاندار پائالىيەت چىقىمى",
    merchantExpenceDisocunt: "ئېتبار مەھسۇلات سوممىسى %{price} يۈەن",
    merchantExpenceCoupon: "ئېتىبار كارتا سوممىسى %{price} يۈەن",
    platformExpence: "سۇپا پائالىيەت چىقىمى",
    platformExpenceDisocunt: "ئېتبار مەھسۇلات سوممىسى %{price} يۈەن",
    platformExpenceCoupon: "ئېتىبار كارتا سوممىسى %{price} يۈەن",
    platformIncome: "بۇلۇت بازار سۇپا چىقىمى",
    platformRate: "بۇلۇت بازار سۇپا نىسپىتى %%{rate}",
    merchantIncome: "بۇ زاكازدىن كىرىدىغان كىرىم",
    refundLog: "پۇل قايتۇرۇش خاتىرىسى",
    refundQuantity: "قايتۇرۇش {{count}}",
    userPayed: "خېرىدار ئەمەلىي تۆلىگەن پۇل :",
    userPayedProductFee: "  تۆلىگەن مال پۇلى :",
    userPayedShipPriceFee: "  تۆلىگەن كىرا پۇلى :",
    paymentFee: "ئۈندىدار پۇل تۆلەش ھەققى",
    statusPayed: "(تۆلەپ بولغان)",
    orderTime: "زاكاز ۋاقتى：",
    orderNo: "زاكاز نومۇرى：",
    jdOrderNo: "جىڭدۇڭ زاكاز نومۇرى：",
    bbOrderNo: "زاكاز ID：",
    orderShipNo: "يوللانما نومۇرى：",
    copyShipNo: "يوللانما نومۇرىنى كۆچۈرۈش",
    copyShipNoSuccess: "مۇۋەپپەقىيەتلىك كۆچۈرۈلدى",
    copyShipNoFailed: "كۆچۈرۈش مەغلۇپ بولدى",
    accept: "قۇبۇل قىلىش",
    acceptHint: "بۇ زاكازنى راستىنلا قۇبۇل قىلامسىز ؟",
    accepting: "زاكاز قۇبۇل قىلىنىۋاتىدۇ ...",
    cancel: "رەت قىلىش",
    cancelHint: "بۇ زاكازنى راستىنلا رەت قىلامسىز ؟",
    canceling: "زاكاز رەت قىلىنىۋاتىدۇ ...",
    send: "مال سېلىش",
    prepared: "تاماق (مال) تەييارلاندى",
    delivered: "يەتكۈزۈلدى",
    reject: "رەت قىلىش",
    sendTitle: "زاكاز مال سېلىش",
    discountTitle: "ئېتىبار باھا",
    sendTrackName: "يوللانما  ئىسمى",
    sendTrackDate: "مال سالغان ۋاقىت",
    sendTrackReciet: "تالون",
    sendTrackNameHint: "يوللانما ئىسمىنى تاللاڭ",
    sendTrackReason: "ئىزاھات",
    sendTrackNumber: "يوللانما نومۇرى",
    sendTrackNumberHint: "يوللانما نومۇرىنى كىرگۈزۈڭ",
    sendShipWeight: "ئېغىرلىقى",
    sendShipWeightUnit: "كىلوگىرام",
    sendShipWeightHint: "يوللانما ئغىرلىقىنى كىرگۈزۈڭ",
    sendShipPrice: "توشۇش ھەققى",
    sendShipReceipt: "تالون",
    sendShipPriceUnit: "يۈەن",
    sendShipPriceHint: "توشۇش ھەققىنى كىرگۈزۈڭ",
    sending: "مال سېلىش ئۇچۇرى يوللىنىۋاتىدۇ ...",
    sendChange: "يوللانما ئۆزگەرتىش",
    sendChangeTitle: "زاكاز يوللانما ئۇچۇرىنى ئۆزگەرتىش",
    sendChanging: "زاكاز يوللانما ئۇچۇرى يېڭىلىنىۋاتىدۇ ...",
    user: "زاكاز چۈشۈرگۈچى：(%{user})",
    kuaidi100Title: "تېز يوللانما تەكشۈرۈش",
    addForm: "قوشۇمەن",
    deleteForm: "ئۆچۈرىمەن",
    importErrorCheck: "خاتالىق ئۇچۇرىنى كۆرىمەن",
    calculate: "پايدا ئايرىش",
    parentCommission: "يۈەن %{price} ئاتا ۋاكالەتچى پايدىسى",
    childCommission: "يۈەن %{price} ۋاكالەتچى پايدىسى",
    refund: "پۇل قايتۇرۇش",
    refundCount: "قايتۇرىدىغان سانى:",
    refundMax: "ئەڭ كۆپ بولغاندا %{max}نى قايتۇرغىلى بولىدۇ",
    refundConfirm: "پۇل قايتۇرامسىز؟",
    refundAmount: "قايتۇرغان سانى %{amount}",
    refundPrice: "قايتۇرغان پۇلى %{price} يۈەن",
    atLeastRefund: "پۇل قايتۇرىدىغان مەھسۇلاتنى تاللاڭ",
    refundReasonWarning: "پۇل قايتۇرۇش سەۋەبىنى يېزىڭ",
    refundReason: "پۇل قايتۇرۇش سەۋەبى نىمە؟",
    refundCheck: "پۇل قايتۇرۇلىشىنى تەكشۈرۈش",
    refundAccept: "پۇل قايتۇرۇش",
    refundReject: "رەت قىلىش",
    refundAcceptAfterReject: "مالنى رەت قىلغاندا پۇل قايتۇرۇش",
    refundAcceptAfterReturn: "مال قايتۇرغاندا پۇل قايتۇرۇش",
    status: "زاكاز ھالىتى",
  },
  shows: {
    type: {
      all: "ھەممىسى",
      text: "تېكىست",
      image: "رەسىم",
      video: "فىلىم",
      audio: "ئاۋاز",
    },
    status: {
      all: "ھەممىسى",
      valid: "تەستىقلانغان",
      invalid: "تەستىقلانمىغان",
      draft: "يوللانمىغان",
      rejected: "رەت قىلىنغان",
      active: "تەستىقلانغان",
      inactive: "تەستىقلانمىغان",
    },
    sortTypes: {
      created_at_desc: "يېڭى يوللانغىنى",
      created_at_asc: "بۇرۇن يوللانغىنى",
    },
    noTags: "ماركا يوق",
    mediaTypesTitle: "ۋاستە",
    orderTypesTitle: "ھالىتى",
    sortTypesTitle: "تەرتىپى",
    showsTitle: "مەزمۇنلار",
    loadingShow: "ئۇچۇر كېلىۋاتىدۇ",
    loadingShowEmpty: "مەزمۇن يوق",
    showsTitleCount: "جەمئى %{total} پارچە مەزمۇن بار",
    deleteConfirm: "راستىنلا ئۆچۈرىمەن",
    categories: "تۈرلەر",
    add: "يېڭى مەزمۇن قوشۇش",
  },
  showsEdit: {
    videoCover: "مۇقاۋىسى",
    headerTitle: "يېڭى مەزمۇن",
    headerTitleEdit: "تەھرىرلەش",
    creatingShowSuccess: "مۇۋەپپەقىيەتلىك قېتىلدى",
    updatingProductSuccess: "مۇۋەپپەقىيەتلىك يېڭىلاندى",
    selectProduct: "مەھسۇلات تاللاڭ",
    selectCoupon: "ئېتىبار كارتىسى تاللاڭ",
    bindProduct: "مەھسۇلاتقا باغلاش",
    catLabel: "تۈرلەر",
    nameLabel: "مەزمۇنى",
    nameHint: "مەزمۇنىنى تولدۇرۇڭ",
    nameRequired: "قۇرۇق قالمىسۇن",
    imagesLabel: "رەسىم",
    tagLabel: "ماركا",
    tagHint: "ماركا تاللاڭ",
    statusLabel: "ۋاستە",
    languageLabel: "تىلى",
    productLabel: "ماركا",
    status: {
      image: "رەسىم",
      video: "فىلىم",
      text: "تېكىست",
    },
    orderLabel: "تەرتىپى",
    addTag: "ماركا قوشۇش",
    orderIdLabel: "زاكاز نومۇرى",
  },
  product: {
    filter: {
      all: "ھەممىسى",
      onShelf: "سېتىلىۋاتقان",
      offShelf: "توختىتىلغان",
      discounted: "باھاسى چۈشۈرۈلگەن",
      order_desc: "پايدا نىسپىتى يۇقىرى",
      order_asc: "پايدا نىسپىتى تۆۋەن",
      price_start: "تۆۋەن",
      price_end: "يۇقىرى",
      quantity_desc: "ئامبار سانى جىق",
      quantity_asc: "ئامبار سانى ئاز",
      createdAtRange: "قۇرۇلغان ۋاقىت",
    },
    stats: {
      newProducts: "يېڭى مەھسۇلات",
      onShelfCount: "سېتىلىۋاتقان",
      offShelfCount: "توختىتىلغان",
    },
    search: {
      product_no: "مەھسۇلات نومۇرى",
      barcode: "تاياقچە كود",
      name: "مەھسۇلات نامى",
    },
    discount: {
      title: "مەھسۇلاتنى پائالىيەت قىلىش",
      priceLabel: "ئېتىبار باھا",
      discountedPriceHint: "ئېتىبار باھانى كىرگۈزۈڭ",
      discounting: "ئېتىبار باھا ئۇچۇرى يوللىنىۋاتىدۇ ...",
    },
    loadingCatsData: "تۈر ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    loadingProductsData: "مەھسۇلات تىزىملىك ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    headerCreate: "مەھسۇلات قوشۇش",
    headerSeatchHint: "",
    catsTitle: "تۈر تىزىملىكى",
    catsManage: "تۈر باشقۇرۇش",
    catsLoading: "تۈر ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    catsNull: "ھازىرچە تۈر ئۇچۇرى يوق",
    catsEmpty: "تېخى تۈر قوشۇلمىغان",
    selectAll: "ھەممىنى تاللاش",
    batchOnShelf: "ئوپچە چىقىرىش",
    batchOffShelf: "ئوپچە توختۇتۇش",
    batchFreeShipping: "ئوپچە كىرا يوق",
    batchCancelFreeShipping: "كىرانى ئەسلىگە كەلتۈرۈش",
    batchDelete: "ئوپچە ئۆچۈرۈش",
    productsEmpty: "ھازىرچە مۇناسىۋەتلىك مەھسۇلات ئۇچۇرى يوق",
    catsModalTitle: "تۈر باشقۇرۇش",
    catsModalOkText: "مۇقىملاش",
    catsModalCancelText: "قالدۇرۇش",
    catsModalAvailable: "تاللانمىغان تۈرلەر",
    catsModalSelected: "دۇكان تۈرلىرى",
    catsModalAdd: "قوشۇش",
    catsModalRemove: "چىقىرۋېتىش",
    catsModalInclude: " (%{count} تال مەھسۇلات بار)",
    catsModalIncludeWarning: "مەھسۇلات بار تۈرنى چىقىرۋەتكىلى بولمايدۇ",
    updatingProduct: "مەھسۇلات ئۇچۇرنى يېڭىلاۋاتىدۇ ...",
    updatingProductSuccess:
      "مەھسۇلات ئۇچۇرى مۇۋەپپەقىيەتلىك يېڭىلاندى، يېڭى ئۇچۇر يۈكلىنىۋاتىدۇ ...",
    priceRangeAlert: "ئەڭ تۆۋەن باھا ئەڭ يۇقىرى باھادىن يۇقىرىكەن",
    productItem: {
      offShelf: "توختىتىلغان",
      monthySale: "سېتىلىشى %{count}",
      likes: "ياقتۇرۇلىشى %{count}",
      quantity: "سانى",
      quantityLimitless: "تۈگىمەس",
      quantityZero: "تۈگىدى",
      actionUp: "چىقىرىش",
      actionDown: "توختۇتۇش",
      actionConfirm: "مۇقىملاش",
      actionDelete: "ئۆچۈرۈش",
      actionEdit: "تەھرىرلەش",
      actionCancel: "قالدۇرۇش",
      oneKeyCopy: "نەق مەيدان ئادىرىسى",
      skuImage: "/assets/images/product-item-sku-ug.png",
      actionClone: "كۆپەيتىش",
      actionQrcode: "ئىككى ئۆلچەملىك كود",
    },
    qrcode: {
      title: "مەھسۇلات ئىككى ئۆلچەملىك كودى",
      generating: "ئىككى ئۆلچەملىك كود ھازىرلىنىۋاتىدۇ...",
      generateError: "ئىككى ئۆلچەملىك كود ھاسىل قىلىش مەغلۇپ بولدى",
    },
    cats: {
      actions: "مەشغۇلات",
      addChild: "بالا سەھىپە قوشۇش",
      edit: "تەھرىرلەش",
      delete: "ئ‍ۆچۈرۈش",
      search: "ئىزدىمەكچى بولغان سەھىپە نامىنى كىرگۈزۈڭ",
      add: "سەھىپە قوشۇش",
      deleteWarning: "بۇ سەھىپىنى ئۆچۈرەمسىز؟",
      catWarning: "سەھىپە يوق ئىكەن",
      catEditWarning: "سەھىپە يوق ئىكەن",
      zhName: "خەنزۇچە سەھىپە نامى",
      ugName: "ئۇيغۇرچە سەھىپە نامى",
      save: "ساقلاش",
      cancel: "قالدۇرۇش",
    },
  },
  productEdit: {
    status: {
      onShelf: "چىقىرىش",
      offShelf: "توختۇتۇش",
    },
    suggest: {
      on: "تەۋسىيەلەش",
      off: "تەۋسىيەدىن قالدۇرۇش",
    },
    headerTitle: "مەھسۇلات قوشۇش",
    headerTitleEdit: "مەھسۇلات تەھرىرلەش",
    video: "فىلىم",
    headerBack: "قايتىش",
    catLabel: "مەھسۇلات تۈرى",
    catRequired: "مەھسۇلات تۈرى قۇرۇق بولمىسۇن",
    nameLabel: "مەھسۇلات نامى (خەنزۇچە)",
    nameHint: "مەھسۇلات خەنزۇچە نامىنى كىرگۈزۈڭ",
    numberLabel: "مال نومۇرى",
    numberHint: "مال نومۇرىنى كىرگۈزۈڭ",
    numberRequired: "مال نومۇرى قۇرۇق بولمىسۇن",
    valid_date: "ساقلاش مۇددىتى",
    validHint: "ساقلاش مۇددىتىنى كىرگۈزۈڭ",
    manufactured_date: "ئىشلەپچىقىرىش ۋاقتى",
    recommended_price: "پارچە سېتىش باھاسى",
    recommendedHint: "پارچە سېتىش باھاسىنى كىرگۈزۈڭ",
    basic_sales: "مەۋھۈم سېتىلىشى",
    basicHint: "مەۋھۇم سېتىلىشىنى كىرگۈزۈڭ",
    barcodeLabel: "تاياقچە كود",
    barcodeHint: "تاياقچە كودنى كىرگۈزۈڭ",
    baseUnitBarcodeLabel: "تاياقچە كود (ئاساسىي بىرلىك)",
    baseUnitBarcodeHint: "ئاساسىي بىرلىك تاياقچە كودىنى كىرگۈزۈڭ",
    packUnitBarcodeLabel: "تاياقچە كود (چوڭ بىرلىك)",
    packUnitBarcodeHint: "چوڭ بىرلىك تاياقچە كودىنى كىرگۈزۈڭ",
    nameRequired: "مەھسۇلات خەنزۇچە نامى قۇرۇق بولمىسۇن",
    nameUgLabel: "مەھسۇلات نامى (ئۇيغۇرچە)",
    nameUgHint: "مەھسۇلات ئۇيغۇرچە نامىنى كىرگۈزۈڭ",
    imagesLabel: "مەھسۇلات رەسىمى",
    zhImagesLabel: "تۆت كاتەك رەسىم(خەنزۇچە)",
    ugImagesLabel: "تۆت كاتەك رەسىم(ئۇيغۇرچە)",
    imagesUpload: "قوشۇش",
    aspectRatioTip: "تەۋسىيە قىلىنغان نىسبەت: {ratio}",
    cropImage: "رەسىم كېسىش",
    zoom: "كىچىكلەشتۈرۈش/چوڭايتىش",
    uploadError: "يۈكلەش مەغلۇپ بولدى",
    selectFromLibrary: "ياكى مېدىيا كۇتۇپخانىسىدىن تاللاڭ",
    imagesRequired: "مەھسۇلات رەسىمى ئەڭ ئاز بولغاندا بىر تال بولسۇن",
    descLabel: "چۈشەندۈرلىشى (خەنزۇچە)",
    detailLabel: "تەپسىلاتى",
    detailImagesLabel: "تەپسىلات رەسىملىرى",
    detailImagesHint:
      "رەسىم يۈكلەڭ ۋە سۆرەپ تەرتىپنى تەڭشەڭ، تەپسىلات بېتى بۇ تەرتىپتە كۆرۈنىدۇ",
    detailImagesEmpty:
      "تەپسىلات رەسىمى يوق، تۆۋەندىن يۈكلەڭ ياكى مېدىيا كۇتۇپخانىسىدىن تاللاڭ",
    descHint: "مەھسۇلات خەنزۇچە چۈشەندۈرلىشىنى يېزىڭ، 400 خەت بىلەن چەكلىنىدۇ",
    descUgLabel: "چۈشەندۈرلىشى (ئۇيغۇرچە)",
    detailDescLabel: "تەپسىلىي چۈشەندۈرۈلىشى (خەنزۇچە)",
    detailDescLabelHint:
      "بۇ مەھسۇلاتنىڭ خالتا، قۇتا ۋە يەشىك ئۇچۇرىنى تولدۇرۇڭ",
    detailUgDescLabelHint:
      "بۇ مەھسۇلاتنىڭ خالتا، قۇتا ۋە يەشىك ئۇچۇرىنى تولدۇرۇڭ (ئۇيغۇرچە)",
    detailDescUgLabel: "تەپسىلىي چۈشەندۈرۈلىشى (ئۇيغۇرچە)",
    descUgHint:
      "مەھسۇلات ئۇيغۇرچە چۈشەندۈرلىشىنى يېزىڭ، 400 خەت بىلەن چەكلىنىدۇ",
    standardLabel: "مەھسۇلات باھاسى: ",
    propertyLabel: "مەھسۇلات ئۆلچىمى",
    multiSpecProduct: "كۆپ ئۆلچەملىك مەھسۇلات",
    multiSpecProductHint: "ئېچكەندىن كېيىن ئۆلچەم ۋە باھا-ئامبار بەلگىلەش",
    multiSpecPriceHint: "«مەھسۇلات ئۆلچىمى» بەتتە باھا-ئامبار بەلگىلەڭ",
    multiSpecPriceRange: "باھا دائىرىسى",
    inPriceLabel: "كىرىش باھاسى: ",
    shipPriceLabel: "كىرا ھەققى: ",
    maxBuyLimitLabel: "ئەڭ كۆپ سېتىۋېلىش سانى: ",
    minBuyLimitLabel: "ئەڭ ئاز سېتىۋېلىش سانى: ",
    inPriceLabelShort: "كىرىش:",
    outPriceLabel: "سېتىش باھاسى",
    outPriceLabelShort: "سېتىش: ",
    commission: "پايدا",
    parentCommission: "باش پايدا",
    quantityLabel: "سانى: ",
    packPriceLabel: "قاچىلاش ھەققى",
    packCountLabel: "قاچىلاش سانى",
    baseUnitLabel: "ئاساسىي بىرلىك：",
    packUnitLabel: "چوڭ بىرلىك：",
    packSizeLabel: "1 چوڭ بىرلىكتە ئاساسىي بىرلىك سانى：",
    packUnitHint: "مەسىلەن：1 × ساندۇق = 15 بوتۇلكا",
    hasPackUnit: "چوڭ بىرلىكنى قوزغىتىش",
    packUnitPriceLabel: "چوڭ بىرلىك باھاسى：",
    selectUnit: "بىرلىك تاللاڭ",
    manageUnitsHint: "ئاۋۋال «بىرلىك باشقۇرۇش» تىن بىرلىك قوشۇڭ",
    baseUnitRequired: "ئاۋۋال ئاساسىي بىرلىكنى تاللاڭ",
    standardRequired: "قۇرۇق بولمىسۇن",
    statusLabel: "مەھسۇلات ھالىتى",
    orderLabel: "مەھسۇلات تەرتىپى",
    suggestLabel: "تەۋسىيە ھالىتى",
    skuImage: "/assets/images/product-edit-sku-ug.png",
    saveAndBack: "ساقلاپ چېكىنىش",
    save: "ساقلاش",
    saveAndContinue: "ساقلاپ داۋاملىق قوشۇش",
    cancel: "قالدۇرۇش",
    skuWarning: "سۇپا مەھسۇلاتىنى تەھرىرلىگىلى بولمايدۇ",
    creatingProduct: "مەھسۇلات قوشۇلىۋاتىدۇ ...",
    creatingProductSuccess: "مەھسۇلات قوشۇش مۇۋەپپەقىقيەتلىك بولدى",
    updatingProduct: "مەھسۇلات ئۇچۇرى يېڭىلىنىۋاتىدۇ ...",
    updatingProductSuccess: "مەھسۇلات ئۇچۇرى مۇۋەپپەقىيەتلىك يېڭىلاندى",
    uploadingImages: "رەسىم يوللىنىۋاتىدۇ ...",
    uploadImageTypeWarning:
      "رەسىم ھۆججەت شەكلى چوقۇم .jpg/.jpeg/.png بولۇشى كېرەك !",
    uploadImageSizeWarning:
      "رەسىم ھۆججەت چوڭ-كىچىكلىكى 1MB دىن ئېشىپ كەتمىسۇن !",
    uploadVideoSizeWarning:
      "فىلىم ھۆججەت چوڭ-كىچىكلىكى 3MB دىن ئېشىپ كەتمىسۇن !",
    uploadNavImageSizeWarning:
      "رەسىم ھۆججەت چوڭ-كىچىكلىكى 1MB دىن ئېشىپ كەتمىسۇن !",
    delete: "بۇ مەھسۇلاتنى ئۆچۈرەمسىز؟",
    translate: "تەرجىمە",
    isAgentLevelProduct: "ۋاكالەتچى دەرىجە",
    refetchImgs: "رەسىمنى يېڭىلاش",
    refetchDesc: "تەپسىلاتنى يېڭىلاش",
    restorePrice: "ئەسلىگە قايتۇرۇش",
    priceDiscount: "باھاسىنى چۈشۈرۈش",
    basicInfo: "ئاساسى ئۇچۇرلىرى",
    priceInfo: "باھا ئۇچۇرلىرى",
    otherInfo: "باشقا ئۇچۇرلار",
    commissionInfo: "پايدا ئايرىش",
    isFreeShipping: "كىرا ھەقسىزمۇ",
    freeShipping: "كىرا يوق",
    notFreeShipping: "كىرا بار",
    imagesZhLabel: "رامكا رەسىم (خەنزۇچە)",
    imagesUgLabel: "رامكا رەسىم (ئۇيغۇرچە)",
    douyinOrder: "دوۋيىن",
  },
  review: {
    status: {
      all: "ھەممىسى",
      reviewed: "جاۋاپ قايتۇرۇلغان",
      unReviewed: "جاۋاپ قايتۇرۇلمىغان",
    },
    satisfaction: {
      all: "ھەممىسى",
      best: "ياخشى",
      normal: "نورمال",
      worst: "ناچار",
    },
    content: {
      all: "ھەممىسى",
      noContent: "مەزمۇن بار",
    },
    loadingData: "باھالار تىزىملىك ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    loadingDataEpmty: "مۇناسىۋەتلىك باھالار ئۇچۇرى يوق",
    updatingData: "باھالار تىزىملىك ئۇچۇرى يېڭىلىنىۋاتىدۇ ...",
    headerTitle: "يېقىنقى 30 كۈندىكى باھالار ئىستاتىستىكىسى：",
    headerMerchant: "دۇكان باھاسى",
    headerClient: "خېرىدار مەمنۇنلىقى",
    filterStatus: "باھا      ھالىتى",
    filterSatisfaction: "باھا دەرىجىسى",
    filterContent: "باھا   مەزمۇنى",
    filterDate: "باھا       ۋاقتى",
    listTitle: "مۇناسىۋەتلىك باھا: %{count} تال",
    replyValidWarning: "جاۋاپ مەزمۇنىنى كىرگۈزۈڭ",
    replyLengthWarning: "جاۋاپ مەزمۇنى 300 خەتتىن ئېشىپ كەتمىسۇن",
    replyCommitting: "جاۋاپ يوللىنىۋاتىدۇ ...",
    replyCommittingSuccess:
      "جاۋاپ مۇۋەپپەقىيەتلىك يوللاندى، ئۇچۇر يېڭىلىنىۋاتىدۇ ...",
    reviewItem: {
      score5: "ئېسىل",
      score4: "ياخشى",
      score3: "نورمال",
      score2: "بولىدۇ",
      score1: "ناچار",
      merchantScore: "دۇكانچى باھاسى %{score} يۇلتۇز：%{scoreText}",
      merchantText: "دۇكانچى",
      deliveryText: "يەتكۈزۈش",
      ovewrallText: "ئۇمۇمىي",
      overallOk: "رازى بولدۇم",
      overallNotOk: "رازى بولمۇدۇم",
      noContent: "مەزمۇن يوق",
      noImage: "رەسىم يوق",
      replyText: "جاۋاپ：",
      noReply: "جاۋاپ قايتۇرۇلمىغان",
      actionReply: "جاۋاپ قايتۇرۇش",
      replyHint:
        "مەزمۇن 300 خەتتىن ئېشىپ كەتمىسۇن، ئەگەردە يامان مەقسەتتە جاۋاپ قايتۇرۇپ بايقىلىپ قالسىڭىز" +
        " مەسئۇلىيىتىڭىز ئېغىر سۈرۈشتە قىلىنىدۇ",
      replyConfirm: "مۇقىملاشتۇرۇش",
      replyCancel: "قالدۇرۇش",
      detailLabel: "زاكاز تەپسىلاتى",
    },
  },
  financeHome: {
    loadingData: "ھېسابات ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    loadingEmpty: "ھازىرچە مۇناسىۋەتلىك ئۇچۇر يوق",
    headerTitle: "ھېسابات ئۇچۇرى",
    headerAllBills: "ھەممە ھېسابات",
    listTitle: "بوغۇلغان ھېسابات",
    listTitleUnsettled: "بوغۇلمىغان ھېسابات",
    listHeaderDate: "چېسىلا",
    listHeaderSum: "ھېسابات سوممىسى",
    listHeaderActions: "مەشغۇلات",
    listHeaderDetails: "ھېسابات ئۇچۇرى",
    listItemActionDetails: "تەپسىلاتى",
    listItemActionDownload: "چۈشۈرۈش",
    listGroupTime: "%{start_date} دىن %{end_date} گىچە بولغان ھېسابات",
    listGroupInfo: "ھېساپ بوغۇلۇپ بولغان >",
    listGroupInfoUnsettled: "پىلاندا %{sign_date} كۈنى ھېسابات قىلىنىدۇ",
  },
  financeCheck: {
    selectTime: "ۋاقىت تاللاڭ",
    allTime: "ھەممە ۋاقىت",
    loadingSettledData: "بوغۇلغان ھېسابات ئۇچۇرى يۈكلىنىۋاتىدۇ...",
    loadingUnsettledData: "بوغۇلمىغان ھېسابات ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
  },
  financeAccount: {
    times: {
      month: "30 كۈن",
      season: "90 كۈن",
      custom: "ئىختىيارى",
    },
    settlementTypes: {
      cycle: "دەۋري ھېسابات قىلىش",
    },
    loadingData: "ھېسابات ئاكونت ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    loadingEmpty: "ھازىرچە مۇناسىۋەتلىك ئۇچۇر يوق",
    ballanceInfoTitle: "ھېسابات ئۇچۇرى",
    ballanceInfoCycle: "ھېسابات دەۋري",
    ballanceInfoCycleValue: "%{day} كۈندە بىر",
    ballanceInfoCycleType: "ھېسابات قىلىش شەكلى",
    ballanceInfoMin: "ئەڭ تۆۋەن ھېسابات سوممىسى",
    ballanceInfoValue: "%{amount} يۈەن",
    ballanceInfoContact: "مالىيە ئالاقىلاشقۇچى",
    ballanceInfoContactPhone: "ئالاقىلاشقۇچى نومۇرى",
    bankInfoTitle: "بانكا ئۇچۇرى",
    bankInfoNameFull: "بانكا نامى(تولۇق نامى)",
    bankInfoBankTypeCompany: "شىركەت",
    bankInfoBankTypePrivate: "شەخسىي",
    bankInfoBranchId: "بىرلەشمە بانكا نومۇرى",
    bankInfoType: "ئاكونت شەكلىي",
    bankInfoAddressCode: "رايون نومۇرى",
    bankInfoName: "بانكا نامى(قىسقا نامى)",
    bankInfoAccount: "بانكا كارتا نومۇرى",
    bankInfoAccountName: "بانكا ئاكونت نامى",
    bankCardImage: "بانكا كارتىسى (ئاپتوماتىك تونۇش)",
    bankProvince: "ئۆلكە",
    bankCity: "شەھەر",
    selectBank: "بانكا تاللاش",
    searchBank: "بانكا ئىزدەش",
    selectBranch: "شۆبە تاللاش",
    loadingBranches: "شۆبە تىزىملىكى يۈكلىنىۋاتىدۇ…",
    bankBranchHint: "شۆبە تاللانسا بىرلەشمە نومۇر ئاپتوماتىك تولدۇرۇلىدۇ",
    bankAddressCodeHint: "6 خانىلىق رايون نومۇرى، شەھەر تاللانغاندىن كېيىن ئالدىن تولدۇرۇلىدۇ",
    ocrRunning: "ئۇچۇر تونۇلىۋاتىدۇ…",
    ocrFilled: "تونۇش نەتىجىسى بويىچە تولدۇرۇلدى",
    ocrFailed: "تونۇش مەغلۇپ بولدى، قولدا تولدۇرۇڭ",
    organizationType: "تۈرى",
    organizationTypeMicro: "مىكرو تىجارەتچى",
    organizationTypePersonal: "شەخسى",
    organizationTypeIndividual: "شەخسىي تىجارەتچى",
    organizationTypeEnterprise: "شىركەت",
    organizationTypeGovernment: "ھۆكۈمەت ئورنى",
    organizationTypeOther: "باشقا ئورگانلار",
    contactType: "ئالاقىلاشقۇچى شەكلى",
    contactTypeLegal: "قانۇن ۋەكىلى",
    contactTypePersonInCharge: "مەسئۇل خادىم",
    agentInfoHint:
      "مەسئۇل خادىم ئۈندىدار پۇل تۆلەش باشقۇرغۇچىسى سۈپىتىدە كېلىشىمگە ئىمزا قويىدۇ. بانكا ئۇچۇرى بەتكۈچىدە مەسئۇل خادىمنىڭ تېلېفون نومۇرىنى تولدۇرۇڭ.",
    agentFullName: "مەسئۇل خادىم ئىسمى",
    agentIdNumber: "مەسئۇل خادىم كىملىك نومۇرى",
    agentIdCardFront: "مەسئۇل خادىم كىملىك ئالدى",
    agentIdCardBack: "مەسئۇل خادىم كىملىك كەينى",
    agentIdStartDate: "مەسئۇل خادىم كىملىك باشلىنىش ۋاقتى",
    agentIdEndDate: "مەسئۇل خادىم كىملىك ئاخىرلىشىش ۋاقتى",
    agentIdLongTerm: "مەسئۇل خادىم كىملىك ئۇزۇن مۇددەت",
    agentContactPhoneHint: "مەسئۇل خادىم تېلېفون نومۇرى (كېلىشىم ۋە دەلىللەش كودى)",
    contact_email: "ئىلخەت",
    listTitle: "ھېسابات تالون خاتىرسى",
    listFilterTime: "ۋاقىت تاللاڭ",
    listHeaderDate: "چېسىلا",
    listHeaderName: "ھېسابات نامى",
    listHeaderAmount: "ھېسابات سوممىسى",
    listHeaderStatus: "ھالىتى",
    listHeaderAction: "مەشغۇلات",
    listItemName: "%{start_date} دىن %{end_date} غىچە ھېسابات",
    checkoutDateLabel: "%{checkout_date}ھېسابات",
    listItemAmount: "%{amount} يۈەن",
    listItemStatusSuccess: "تامام بولدى",
    listItemActionDetails: "تەپسىلاتى",
    basicInfo: "ئاساسى ئۇچۇرى",
    merchantAccountInfo: "بانكا ئۇچۇرى",
    merchantInfo: "سودا سانائەت ئۇچۇرى",
    licences: "كىنىشكە",
    licenceNumber: "كىنىشكە نومۇرى",
    licenceName: "كىنىشكىدىكى ئىسمى",
    licenceImage: "كىنىشكە رەسىمى",
    licenceLegal: "قانۇن ۋەكىلى",
    licenceIdCardFront: "كىملىك ئالدى",
    licenceIdCardBack: "كىملىك كەينى",
    licenceIdName: "كىملىكتىكى ئىسمى",
    licenceIdNumber: "كىملىك نومۇرى",
    licenceIdAddress: "كىملىك ئادرېسى",
    licenceIdStartDate: "كىملىك باشلىنىش ۋاقتى",
    licenceIdEndDate: "كىملىك ئاخىرلىشىش ۋاقتى",
    idLongTerm: "ئۇزۇن ۋاقىت",
    merchantAbbr: "قىسقىچە ئىسمى",
    customerNumber: "مۇلازىمەت نومۇرى",
    logo: "دۇكان باش رەسىمى",
  },
  financeDownload: {
    tabs: {
      generate: "ھېسابات ۋاقتىنى تاللاش",
      history: "ھېسابات ھاسىللاش تارىخى",
    },
    times: {
      month: "1 كۈن",
      season: "7 كۈن",
      custom: "ئىختىيارى",
    },
    loadingData: "ھېسابات ھاسىللاش تارىخى ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    loadingEmpty: "ھازىرچە مۇناسىۋەتلىك ئۇچۇر يوق",
    generateFilterTime: "چېسلانى تاللاڭ",
    generateActionGenerate: "ھېسابات ھاسىللاش",
    historyHeaderNo: "تەرتىپى",
    historyHeaderName: "ھۆججەت نامى",
    historyHeaderStatus: "ھالىتى",
    historyHeaderActions: "مەشغۇلات",
    listItemName: "%{start_date} دىن %{end_date} غىچە ھېسابات",
    checkoutDateLabel: "%{checkout_date} ھېسابات",
    historyItemStatusSuccess: "ئوڭۇشلۇق بولدى",
    historyItemStatusGenerating: "ھاسىىللىنىۋاتىدۇ ...",
    historyItemStatusFailed: "مەغلۇپ بولدى",
    historyItemActionDownload: "چۈشۈرۈش",
    historyItemActionDelete: "ئۆچۈرۈش",
    historyItemActionDeleteWarning: "بۇ ھېساباتنى راستىنلا ئۆچۈرەمسىز ؟",
    historyItemActionDeleteWarningOk: "ھەئە",
    historyItemActionDeleteWarningCancel: "بولدى",
    generating: "ھېسابات ھاسىللىنىۋاتىدۇ ...",
    generatingWarning:
      "ھسېسابات ھاسىللىنىۋاتىدۇ، بىر ئازدىن كىيىن مەشغۇلات قىلىڭ !",
    deleting: "ھېسابات ئۆچۈرلىۋاتىدۇ ...",
    generateSuccess:
      "ھېسابات مۇۋەپپەقىيەتلىك يوللاندى، ئۇچۇر يېڭىلىنىۋاتىدۇ ...",
    updatingList: "ئۇچۇر يېڭىلىنىۋاتىدۇ ...",
    deleteSuccess:
      "ھېسابات مۇۋەپپەقىيەتلىك ئۆچۈرۈلدى، ئۇچۇر يېڭىلىنىۋاتىدۇ ...",
    range: "ئەڭ كۆپ بولغاندا 15 كۈنلۈكنى چىقىرالايسىز",
  },
  orderDownload: {
    tabs: {
      generate: "چېسلانى تاللاڭ",
      history: "تارىخى",
    },
    generateActionGenerate: "جەدۋەل چىقىرىش",
    range: "ئەڭ كۆپ بولغاندا ئىككى كۈنلۈكنى چىقىرالايسىز",
    date: "چېسلاسى",
    orderCount: "زاكاز سانى",
  },

  financeBillDetail: {
    loadingData: "ھېسابات تالون تەپسىلات ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    loadingEmpty: "ھازىرچە مۇناسىۋەتلىك ئۇچۇر يوق",
    headerBack: "قايتىش",
    headerTitle: "ھېسابات تالون تەپسىلاتى",
    billAmount: "ھېسابات سوممىسى",
    billAmountValue: "%{amount} يۈەن",
    billAccount: "ھېسابات ئاكونت",
    billType: "ھېسابات شەكلى",
    billTime: "ھېسابات ۋاقتى",
  },
  financeCheckDaily: {
    tabs: {
      order: {
        name: "زاكاز تۈردىكىلەر",
        tabs: {
          all: "ھەممىسى",
          normal: "نورمال زاكاز",
          refund: "پۇل قايتۇرۇلغان",
        },
      },
      other: {
        name: "باشقا تۈردىكىلەر",
        tabs: {
          all: "ھەممىسى",
          ship_fee: "توشۇش ھەققى",
          bad_food: "بۇزۇلغان تاماق تۆلىمى",
          serve_return: "قايتۇرۇلغان مۇلازىمەت ھەققى",
          part_refund: "قىسمەن قايتۇرۇلغان پۇل",
          refund_neutralize: "قىسمەن توغۇرلاش ھەققى",
        },
      },
    },
    loadingData: "كۈنلۈك زاكاز تەپسىلات ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    loadingEmpty: "ھازىرچە مۇناسىۋەتلىك ئۇچۇر يوق",
    headerBack: "قايتىش",
    headerDate: "%{date} كۈندىكى ھېسابات",
    headerInfo: " كۈنى ھېساپ بوغۇلۇپ بولغان",
    headerInfoUnsettled: "پىلاندا %{sign_date} كۈنى ھېسابات قىلىنىدۇ",
    listUnit: "بىرلىكى：يۈەن",
    listHeaderOrderDate: "چېسىلا & تەرتىپى",
    listHeaderOrderType: "شەكلى",
    listHeaderOrderPrice: "ئەسلى باھاسى",
    listHeaderOrderPacking: "قاچىلاش ھەققى",
    listHeaderOrderEvent: "پائالىيەت ھەققى",
    listHeaderOrderPlatform: "سۇپا ھەققى",
    listHeaderOrderShip: "توشۇش ھەققى",
    listHeaderOrderDonate: "ئىئانە ھەققى",
    listHeaderOrderTotal: "جەمئىي",
    listHeaderOrderAction: "مەشغۇلات",
    listHeaderOtherDate: "چېسىلا",
    listHeaderOtherType: "شەكلى",
    listHeaderOtherDetails: "تەپسىلاتى",
    listHeaderOtherTotal: "جەمئىي",
    listHeaderOtherAction: "مەشغۇلات",
    listItemActionDetail: "تەپسىلاتى",
    listFooterTotal: "جەمئىي (%{order_count} تال)",
  },
  financeOrderDetail: {
    headerBack: "قايتىش",
    headerTitle: "زاكاز تەپسىلاتى",
    detailProducts: "مەھسۇلاتلار",
    detailMerchant: "پائالىيەت ھەققى",
    detailPaymentFee: "ئۈندىدار ھەققى",
    detailPlatform: "سۇپا ھەققى",
    detailShip: "توشۇش ھەققى",
    detailDonation: "ئىئانە ھەققى",
    detailTotal: "ئۇرۇلغان ھېسابات",
    footerSequence: "زاكاز تەرتىپى：#%{sequence}",
    footerNo: "زاكاز نومۇرى：%{no}",
    footerTime: "زاكاز ۋاقتى：%{time}",
    footerTimeFinish: "تاماملانغان ۋاقتى：%{time}",
  },
  proxy: {
    loadingData: "ۋاكالەتچىلەر ئۇچۇرى يۈكلىنىۋاتىدۇ ...",
    updatingData: "ۋاكالەتچىلەر ئۇچۇرى يېڭىلىنىۋاتىدۇ ...",
    searchFromParent: "يېتەكچىسىدىن ئىزدەش",
    filterMobile: "تېلېفون       نومۇرى",
    filterMobileHint: "ۋاكالەتچى تېلېفون نومۇرىنى ياكى ئىسمىنى كىرگۈزۈڭ",
    filterLevel: "ۋاكالەتچى دەرىجىسى",
    filterOwner: "ۋاكالەتچىسى بارمۇ يوق",
    filterStatus: "تەستىق ھالىتى",
    addProxy: "ۋاكالەتچى قوشۇش",
    listTitle: "مۇناسىۋەتلىك ۋاكالەتچى %{count} تال",
    listItemLevel: "دەرىجىسى",
    listItemMobile: "تېلېفونى",
    listItemPercent: "پىرسەنتى",
    listItemParent: "يۇقىرىسى",
    listItemParentNone: "يوق",
    listItemEdit: "تەھرىرلەش",
    listItemDelete: "ئۆچۈرۈش",
    viewItems: "تۈرلەرنى كۆرۈش",
    listNoData: "ۋاقتىنچە مۇناسىۋەتلىك ئۇچۇر يوق",
    deleteHint: "بۇ ۋاكالەتچىنى راستىنلا ئۆچۈرەمسىز ؟",
    deleting: "ۋاكالەتچىنى ئۆچۈرۋاتىدۇ ...",
    updating: "ۋاكالەتچىنى يېڭىلاۋاتىدۇ ...",
    adding: "ۋاكالەتچى قۇشۇلۇۋاتىدۇ ...",
    editMobile: "ۋاكالەتچى          تېلېفونى",
    editMobileHint: "ۋاكالەتچى تېلېفون نومۇرنى كىرگۈزۈڭ",
    editMobileLength: "11 خانىلىق تېلېفون نومۇرنى كىرگۈزۈڭ",
    editLevel: "ۋاكالەتچى        دەرىجىسى",
    editProxySwitch: "ۋاكالەتچى قوبۇل قىلسا بولامدۇ",
    editLevelHint: "ۋاكالەتچى دەرىجىسىنى تاللاڭ",
    editPercent: "ۋاكالەتچى           پىرسەنتى",
    editParentMobile: "يۇقىرى  ۋاكالەتچى  تېلېفونى",
    editParentMobileHint: "يۇقىرى ۋاكالەتچى تېلېفون نومۇرنى كىرگۈزۈڭ",
    editParantPercent: "يۇقىرى ۋاكالەتچى پىرسەنتى",
    editTitle: "ۋاكالەتچى قوشۇش",
    editTitleEdit: "ۋاكالەتچى تەھرىرلەش",
    editOk: "مۇقىملاش",
    editCancel: "قالدۇرۇش",
    all: "ھەممىسى",
    owner: "ۋاكالەتچىسى بار",
    notOwner: "ۋاكالەتچىسى يوق",
    reviewing: "تەستىق كۈتىۋاتقان",
    reviewed: "تەستىقتىن ئۆتكەن",
    editProxyStatusSwitch: "تەستىقتىن ئۆتكەن",
    editIsPartnerSwitch: "ھەمكارلاشقۇچى",
    editIsShopOwnerSwitch: "دۇكاندار",
    registerDate: "ئىلتىماس ۋاقتى",
    listProxyTeam: "ۋاكالەتچى سانى",
    listProxyClient: "خېرىدار سانى",
    listProxyOrders: "زاكاز سانى",
    apply: "ۋاكالەتچى بولۇش",
    recommenderList: {
      title: "تەۋسىيە مۇناسىۋىتى",
      merchant: "سودىگەر",
      merchantFilter: "سودىگەر",
      merchantPlaceholder: "سودىگەر تاللاڭ ياكى ئىزدەڭ",
      recommenderFilter: "تەۋسىيە قىلغۇچى",
      recommenderHint: "تەۋسىيە قىلغۇچى يانفون ياكى ئىسمى",
      recommender: "تەۋسىيە قىلغۇچى",
      invitee: "تەكلىپ قىلىنغۇچى",
      agentFilter: "ۋاكالەتچى",
      agent: "ۋاكالەتچى",
      teamCount: "ئەترەت سانى",
      createdAt: "باغلاش ۋاقتى",
      expireDate: "ۋاقتى ئۆتكەن ۋاقىت",
      statusRegistered: "تىزىملاتقان",
      statusNotRegistered: "تىزىملاتمىغان",
      statusExpired: "ۋاقتى ئۆتكەن",
      reset: "قايتا تەڭشەش",
    },
  },
  commissionList: {
    mobile: "يانفون",
    order_no: "زاكاز نومۇرى",
    original: "زاكاز ئەسلى باھاسى",
    price: "زاكاز سوممىسى",
    ship: "كىرا",
    real: "تۆلىگىنى",
    receiver: "تاپشۇرىۋالغۇچى",
    tel: "تېلفونى",
    address: "ئ‍ادىرىسى",
    comm: "پايدىسى",
    channel: "كېلىشى",
    status: "ھالىتى",
    payoutMethod: "تۆلەش ئۇسۇلى",
    order_id: "زاكاز ID",
    unfreeze: "ئېرىتىش",
    confirmFinished: "تاماملاش",
    update: "پوسۇلكا يېڭىلاش",
    confirmReceived: "مال تاپشۇرۇلدى",
    confirmSend: "مال سېلىندى",
    confirm: "تەستىقلاش",
    reject: "رەت قىلىش",
    appliedAmount: "ئىلتىماس قىلغان سوممىسى",
    appliedDate: "ئىلتىماس قىلغان ۋاقىت：%{date}",
    sendWarehouse: "ئامبارغا يوللاش",
    shareableRealPayment: "تۆلىگەن سومما：%{amount}",
    shareableLimit: "بۆلۈشكە بولىدىغان چەك (%{ratio}%)：%{amount}",
    shareableOrderTotal: "زاكاز پايدا جەمئىيى：%{amount}",
    shareableExcess: "ئېشىپ كەتكەن：%{amount}",
    paidOtherWayAction: "باشقىچە پۇل ئۇرۇش",
    paidOtherWayTitle: "باشقىچە پۇل ئۇرۇش",
    paidOtherWayPayType: "پۇل ئۇرۇش ئۇسۇلى",
    paidOtherWayPayTypePlaceholder: "مەسىلەن: بانكا يۆتكىمىسى، نەق پۇل، ئالىپاي",
    paidOtherWayPayTypeRequired: "پۇل ئۇرۇش ئۇسۇلىنى تولدۇرۇڭ",
    paidOtherWayDate: "پۇل ئۇرۇلغان ۋاقىت",
    paidOtherWayDateRequired: "پۇل ئۇرۇلغان ۋاقىتنى تاللاڭ",
    paidOtherWayEvidence: "پۇل ئۇرۇش ئىسپاتى",
    paidOtherWayEvidenceUpload: "ئىسپات يوللاش",
    paidOtherWaySubmit: "جەزملەشتۈرۈش",
  },
  balanceVip: {
    orderNo: "زاكاز نومۇرى",
    user: "ئەزا",
    amount: "سېتىۋېلىش سوممىسى",
    discount: "قۇلۇپلانغان ئېتىبار",
    paidAt: "تۆلەنگەن ۋاقىت",
    status: "ھالىتى",
    action: "مەشغۇلات",
    pendingAccept: "قوبۇل قىلىشنى كۈتۈۋاتىدۇ",
    accepted: "قوبۇل قىلىندى",
    searchPlaceholder: "زاكاز نومۇرى / تېلېفون / ئىسمى",
    refresh: "ئىزدەش",
  },
  specialShareList: {
    tab: "پۇل ئۇرۇش خاتىرىسى",
    amount: "مۇلازىمەت ھەققى",
    billNo: "پۇل ئۇرۇش نومۇرى",
    remark: "ئىزاھات",
    failReason: "مەغلۇپ سەۋەبى",
    sync: "ھالەت يېڭىلاش",
    syncSuccess: "ھالەت يېڭىلاندى",
    searchPlaceholder: "زاكاز نومۇرى / زاكاز ID / ھەمكارلاشقۇچى تېلېفون ياكى ئىسمى",
  },
  specialShareParties: {
    tab: "پۇل قوبۇللىغۇچى تەڭشىكى",
    add: "پۇل قوبۇللىغۇچى قوشۇش",
    addTitle: "ئالاھىدە مۇلازىمەت ھەققى پۇل قوبۇللىغۇچى قوشۇش",
    editTitle: "پۇل قوبۇللىغۇچى تەھرىرلەش",
    percent: "مۇلازىمەت ھەققى نىسبىتى (%)",
    percentHint: "زاكاز ئەمەلىي پۇلى بويىچە ھېسابلىنىدۇ، مەسىلەن 10 = 10%. جەمئىي نىسبەت 30% دىن ئاشماسلىقى كېرەك.",
    percentRequired: "نىسبەتنى كىرگۈزۈڭ",
    displayName: "ئىزاھات ئىسمى",
    displayNamePlaceholder: "ئىختىيارى، ئىچكى ئىزاھات",
    mobileRequired: "تېلېفون نومۇرىنى كىرگۈزۈڭ",
    mobilePlaceholder: "ئىشلەتكۈچى تىزىملاتقان تېلېفون، ئۈندىدار ئەپچاققا باغلانغان بولۇشى كېرەك",
    deleteConfirm: "بۇ پۇل قوبۇللىغۇچىنى ئۆچۈرەمسىز؟",
    selectUser: "پۇل قوبۇللىغۇچى ئىشلەتكۈچى",
    userRequired: "ئىشلەتكۈچىنى تاللاڭ",
    userId: "ئىشلەتكۈچى ID",
    viewOnlyNotice: "پەقەت ئالاھىدە باشقۇرغۇچى قوشۇش ياكى تەھرىرلەشكە بولىدۇ، ھازىر كۆرۈش ھالىتى.",
    totalPercent: "ئېچىلغان نىسبەت جەمئىسى: {{total}}%",
    totalPercentWarning: "ئېچىلغان نىسبەت جەمئىسى {{total}}% — ۋېچات 30% چەكلىمىسىدىن ئاشىپ كەتتى",
  },
  transferAccountList: {
    add: "پۇل ئۇرۇش ھېساباتى قوشۇش",
    refresh: "يېڭىلash",
    label: "ھېسابات ئىسمى",
    mchId: "ئۈندىدار سودىگەر نومۇرى",
    usageToday: "بۈگün ئىشلىتىلگەن / چەك",
    transferCount: "بۈگün سانى",
    purposes: "مەقسەت",
    purpose_commission: "ۋاكالەتچى پايدası",
    purpose_special_share: "ئالاھىدە مۇلازىمەت ھەققى",
    priority: "ئەۋزەللىك",
    status: "ھالەت",
    default: "سۈكۈت",
    enabled: "ئېچىلغان",
    disabled: "تاقاق",
    unlimited: "چەكسىز",
    actions: "مەشغۇلات",
    edit: "تەھرىر",
    delete: "ئۆچür",
    deleteConfirm: "بۇ پۇل ئۇرۇش ھېساباتىنى ئۆچürەمسىز؟",
    createTitle: "پۇل ئۇرۇش ھېساباتى قوشۇش",
    editTitle: "پۇل ئۇرۇش ھېساباتى تەھرىر",
    saved: "ساقلاندى",
    deleted: "ئۆچürüldى",
    uploadFailed: "يوللاش مەغلۇپ",
    labelRequired: "ھېسابات ئىسمىنى تولدۇرۇڭ",
    mchIdRequired: "ئۈندىدار سودىگەر نومۇرىنى تولدۇرۇڭ",
    serialNo: "گۇۋاھنامە تىزىم نومۇرى",
    v3Key: "APIv3 ئاچقۇچ",
    publicKeyId: "ئاممىۋى ئاچقۇچ ID",
    merchantKey: "سودىگەر ئاچقۇچى",
    dailyQuota: "كۈnlük چек(يuan)",
    unlimitedHint: "بوش قويۇlsa چەكسىز",
    upload: "گۇۋاھنامە يوللاش",
    apiCert: "API گۇۋاھنامە",
    apiKey: "API شەخسىي ئاچقۇچ",
    publicKey: "ئۈندىدار پۇل تۆلەش ئاممىۋى ئاچقۇچ",
  },
  wechatRedPacketTopup: {
    refresh: "يېڭىلاش",
    amount: "تولۇقلانغان سومما",
    bookedAt: "خاتىرە ۋاقتى",
    balance: "تولۇقلىغاندىن كېيىنكى قالدۇق",
    businessType: "كەسىپ تۈرى",
    fundFlowNo: "مەبلەغ ئېقىم نومۇرى",
    mchId: "سودىگەر نومۇرى",
    syncHint: "تولۇقلاش خاتىرىسى ئۈندىدار تىجارەت ھېساباتى ھېسابات تالونىدىن ماسقەدەملىنىدۇ، ئادەتتە ئەتىسى ئەتىگەندە كۆرۈنىدۇ. قولدا خاتىرىلەش بولمايدۇ.",
    pausedHint: "تىجارەت ھېساباتى قالدۇقى يېتەرلىك بولمىغاچقا قىزىل بولاق توختىتىلغان. سىستېما ھەر 5 مىنۇتتا قالدۇقنى تەكشۈرۈپ، يېتەرلىك بولسا ئۆزلۈكىدىن ئاچىدۇ.",
  },
  statisticsOverview: {
    title: "ئومۇمىي ئەھۋال",
    noSections: "نۆۋەتتىكى دۇكان ئۈچۈن كۆرگىلى بولىدىغان ستاتىستىكا يوق",
    ordersTitle: "زاكاز ستاتىستىكىسى",
    productsTitle: "مەھسۇلات ستاتىستىكىسى",
    commissionsTitle: "پايدا ستاتىستىكىسى",
    transfersTitle: "پۇل ئۇرۇش ستاتىستىكىسى",
    todayOrders: "بۈگünكى زاكاز",
    yesterdayOrders: "تۈنۈگünكى زاكاز",
    monthOrders: "بۇ ئاي زاكاز",
    todayIncome: "بۈگünكى كىرىم",
    todayTurnover: "بۈگünكى سودا سوممىسى",
    monthIncome: "بۇ ئاي كىرىم",
    orderUnit: "تال",
    productTotal: "مەھسۇلات جەمئىي",
    productInSales: "سېتىلىۋاتقان",
    productStopSelling: "سېتىش توختىتىلغان",
    commissionPending: "ھېسابات قىلىنمىغان",
    commissionPendingAmount: "ھېسابات قىلىنمىغان سومما",
    commissionProcessing: "بىر تەرەپ قىلىنىۋاتقان",
    commissionPaidAmount: "پۇل ئۇرۇلغان سومما",
    commissionFrozen: "توڭلىتىلغان",
    commissionTodayAmount: "بۈگün يېڭى پايدا",
    commissionMonthCount: "بۇ ئاي پايدا سانى",
    commissionMonthAmount: "بۇ ئاي پايدا سوممىسى",
    transferTodayCount: "بۈگün پۇل ئۇرۇش",
    transferTodayAmount: "بۈگün پۇل ئۇرۇش سوممىسى",
    transferSuccessCount: "بۈگün مۇۋەپپەقىيەت",
    transferPendingCount: "بۈگün كۈتۈۋاتقان",
    transferFailedCount: "بۈگün مەغلۇپ",
    transferMonthCount: "بۇ ئاي پۇل ئۇرۇش",
    transferMonthAmount: "بۇ ئاي مۇۋەppەقىيەت سوممىسى",
    transferAccount: "پۇل ئۇرۇش ھېساباتى",
    defaultAccount: "سۈكۈت",
    disabled: "توختىتىلغان",
    mchId: "سودىگەر نومۇرى",
    todayUsage: "بۈگün ئىشلىتىلگەن",
    todayCount: "بۈگün سانى",
    remainingQuota: "قالغان چек",
    unlimited: "چەكسىز",
    chart: {
      week: "7 كۈن",
      month: "30 كۈن",
      season: "90 كۈن",
    },
    commissionTodayCount: "بۈگün يېڭى سانى",
  },
  statisticsCommon: {
    preset7: "7 كۈن",
    preset30: "30 كۈن",
    preset90: "90 كۈن",
    apply: "ئىزدەش",
    trend: "يۈزلىنىش",
    periodCompare: "ئالدىنقى مۇددەت بىلەن سېلىشتۇرۇش",
    previousPeriod: "ئالدىنقى مۇددەت",
    exportCsv: "CSV چۈشۈرۈش",
    action: "مەشغۇلات",
    viewOrders: "زاكازلارنى كۆرۈش",
    viewProducts: "مەھسۇلاتلارنى كۆرۈش",
    viewCommissions: "كومىسسىيەنى كۆرۈش",
    viewTransferAccounts: "پۇل ئۇرۇش ھېساباتى",
  },
  statisticsOrders: {
    title: "زاكاز ستاتىستىكىسى",
    ordersCount: "زاكاز سانى",
    turnover: "سودا سوممىسى",
    merchantIncome: "دۇكان كىرىمى",
    avgOrder: "ئوتتۇرىچە زاكاز",
    amount: "سومما",
    paytype: "پۇل تۆلەش ئۇسۇلى",
    paytypeBreakdown: "پۇل تۆلەش تۈرى بويىچە",
    statusGroups: {
      all: "ھەممىسى",
      completed: "تاماملانغان",
      canceled: "بىكار قىلىنغان",
      refund: "پۇل قايتۇرۇش",
    },
    paytypes: {
      all: "ھەممىسى",
      wechat: "ئۈندىدار",
      balance: "قالدۇق",
      cash: "نەق پۇل",
    },
  },
  statisticsProducts: {
    title: "مەھسۇلات ستاتىستىكىسى",
    newProducts: "مۇددەت ئىچىدە يېڭى مەھسۇلات",
    newProductsTrend: "يېڭى مەھسۇلات يۈزلىنىشى",
    editedProducts: "مۇددەت ئىچىدە تەھرىرلەنگەن مەھسۇلات",
    editedProductsTrend: "تەھرىرلەنگەن مەھسۇلات يۈزلىنىشى",
    salesTrend: "سېتىش يۈزلىنىشى",
    unitsSold: "سېتىلغان سانى",
    salesAmount: "سېتىش سوممىسى",
    activeProducts: "سېتىلغان مەھسۇلات",
    activeRate: "سېتىش نىسبىتى",
    topProducts: "ئەڭ كۆپ سېتىلغان",
    productName: "مەھسۇلات ئىسمى",
    share: "نىسبەت",
    statuses: {
      all: "ھەممىسى",
      in_sales: "سېتىلىۋاتقان",
      stop_selling: "توختىتىلغان",
    },
  },
  statisticsCommissions: {
    title: "كومىسسىيە ستاتىستىكىسى",
    createdCount: "مۇددەت ئىچىدىكى يېڭى سانى",
    createdAmount: "مۇددەت ئىچىدىكى يېڭى سومما",
    count: "سانى",
    amount: "سومما",
    status: "ھالەت",
    agent: "ۋاكالەتچى",
    byStatus: "ھالەت بويىچە",
    topAgents: "ۋاكالەتچى رېتى",
    buckets: {
      all: "ھەممىسى",
      pending: "كۈتۈۋاتقان",
      frozen: "توڭلىتىلغان",
      processing: "بىر تەرەپ قىلىنىۋاتقان",
      paid: "پۇل ئۇرۇلغان",
    },
    orderTypes: {
      all: "ھەممىسى",
      normal: "ئادەتتىكى",
      lottery: "مۇكاپات",
      server: "مۇلازىمەت",
    },
    levels: {
      all: "ھەممىسى",
      1: "بىرىنچى",
      2: "ئىككىنچى",
      3: "ئۈچىنچى",
    },
  },
  statisticsTransfers: {
    title: "پۇل يۆتكەش ستاتىستىكىسى",
    totalCount: "يۆتكەش سانى",
    totalAmount: "يۆتكەش سوممىسى",
    successCount: "مۇۋەپپەقىيەت سانى",
    successAmount: "مۇۋەپپەقىيەت سوممىسى",
    failedCount: "مەغلۇپ سانى",
    pendingCount: "بىر تەرەپ قىلىنىۋاتقان",
    waitConfirmCount: "جەزملەشنى كۈتۈۋاتقان",
    usage: "ئىشلىتىلگەن چек",
    transferCount: "سانى",
    accounts: "ھېسابات ئىشلىتىلىشى",
    types: {
      all: "ھەممىسى",
      commission: "كومىسسىيە نەقلەشتۈرۈش",
      manual: "قولدا يۆتكەش",
    },
    statuses: {
      all: "ھەممىسى",
      success: "مۇۋەپپەقىيەت",
      pending: "بىر تەرەپ قىلىنىۋاتقان",
      failed: "مەغلۇپ",
      wait_confirm: "جەزملەشنى كۈتۈۋاتقان",
    },
    retryTransfers: "مەغلۇپ/كۈتۈۋاتقان يۆتكەشنى قايتا ئۇرۇش",
    retryDone: "قايتا ئۇرۇش يوللاندى: %{retried} مۇۋەپپەقىيەت، %{skipped} ئاتلاندى، %{failed} مەغلۇپ",
    users: "پۇل تاپشۇرۇپ ئالغۇچى ستاتىستىكىسى",
    userName: "ئىسمى",
    userMobile: "يانفون نومۇرى",
    sentAmount: "ھېساباتقا كىرگەن",
    waitingAmount: "جەزملەشنى كۈتۈۋاتقان",
    failedAmount: "مەغلۇپ سوممىسى",
    pendingAmount: "بىر تەرەپ قىلىنىۋاتقان سومما",
  },
  selectLang: {
    zh: "简体中文",
    ug: "ئۇيغۇرچە",
    currentTitle: "ھازىر تاللانغان تىل",
    availableTitle: "تاللاشقا بولىدىغان تىللار",
    switchConfirm: "راستىنلا بۇ تىلنى تاللامسىز ؟",
  },
  importExecl: {
    importing: "جەدۋەل ئوقىلىۋاتىدۇ...",
    historyItemStatusSuccess: "ئوقۇش مۇۋەپپەقىيەتلىك بولدى",
    historyItemStatusFailed: "ئوقۇش مەغلۇب بولدى",
    errorTitle: "خاتالىق ئۇچۇرى",
  },
  productUnit: {
    ugName: "ئۇيغۇرچە نامى",
    zhName: "خەنزۇچە نامى",
    ugNameHint: "ئۇيغۇرچە نامىنى كىرگۈزۈڭ",
    zhNameHint: "خەنزۇچە نامىنى كىرگۈزۈڭ",
    actions: "مەشغۇلات",
    editAction: "تەھرىرلەش",
    deleteAction: "ئۆچۈرۈش",
    add: "بىرلىك قوشۇش",
    edit: "بىرلىك تەھرىرلەش",
    deleteConfirm: "بۇ بىرلىكنى ئۆچۈرەمسىز؟",
    saveSuccess: "ساقلاندى",
    deleteSuccess: "ئۆچۈرۈلدى",
  },
  productImport: {
    productCount: "مەھسۇلات سانى",
    downloadTemplate: "كىرگۈزۈش قېلىپىنى چۈشۈرۈش",
  },
  sales: {
    upload: "يوللاش",
    status: "ھالىتى",
    submit: "تاپشۇرۇش",
    generate: "ئەپچاق ھاسىللاش",
    deleteWarning: "ئۆچۈرەمسىز؟",
    zhTitleWarning: "خەنزۇچە ئىسمىنى تولدۇرۇڭ",
    zhTitle: "خەنزۇچە ئىسمى",
    ugTitleWarning: "ئۇيغۇرچە ئىسمىنى تولدۇرۇڭ",
    ugTitle: "ئۇيغۇرچە ئىسمى",
    save: "يەرلىككە ساقلاش",
    localOk: "داۋام",
    localNew: "يېڭىدىن باشلاش",
    localWarning: "پۈتمىگەن پائالىيەت بايقالدى، داۋاملاشتۇرامسىز؟",
    priceLabel: "ئەسلى￥%{original_price}يۈەن, ھازىر￥%{price}يۈەن",
    ad: {
      lottery: "چاقپەلەك",
      live: "نەق مەيدان",
      webview: "تور بەت",
      add: "ئىلان قوشۇش",
      weapp: "ئەپچاق",
      appId: "ئەپچاقنىڭ APP_ID سى",
      typeWarning: "ئىلان تۈرىنى تاللاڭ",
      product: "مەھسۇلات",
      holiday: "پائالىيەت",
      ranking: "شەرەپ تاختىسى",
      market: "دۇكان",
      groupon: "تالىشىپ سېتىۋىلىش",
      title: "ئىلان تەھرىرلەش",
      order: "تەرتىپى",
      orderPlace: "نۇمۇرى قانچە چوڭ بولسا شۇنچە ئالدىغا تىزىلىدۇ",
      zhImg: "خەنزۇچە رەسىم",
      ugImg: "ئۇيغۇرچە رەسىم",
      imgWarning: "رەسىم يوق",
      type: "تۈرى",
      target: "ئۇلىنىشىنى تاللاڭ",
      show: "ئىلان",
      swiperTip: "باش بەتتىكى سىيرىلما ئىلان ئورنى، رازمېرى 408px*1040px",
      splashTip:
        "ئەپچاقنى ئاچقاندىكى تولۇق ئىكران تەتۈر ساناق بىلەن چىقىدىغان ئىلان",
      popupTip: "ئەپچاق باش بېتى ئىچىلغاندا سەكرەپ چىقىدىغان ئىلان",
      homeAdTip:
        "باش بەتتىكى مەھسۇلات تىزىملىكىنىڭ ئۈستىگە چىقىدىغان رەسىملىك ئىلان، تەگلىكسىز رەسىم قوللايدۇ، رازمېرى 180px*576px",
      zhDescription: "خەنزۇچە چۈشەندۈرۈش",
      ugDescription: "ئۇيغۇرچە چۈشەندۈرۈش",
      isDark: "قاراڭغۇ ئۇسۇل",
      isVideo: "ۋىدىئو ئىشلىتىش",
      adHeight: "ئېلان ئېگىزلىكى",
      adHeightPlace: "ئېكران ئېگىزلىكى نىسبىتى (1-100)",
      adHeightExtra: "بوش قalsa دۇكان تەڭشىكىدىكى سېيرىلما ئېلان ئېگىزلىكى ئىشلىتىلىدۇ",
      ugVideo: "ئۇيغۇرچە ۋىدىئو",
      zhVideo: "خەنزۇچە ۋىدىئو",
    },
    activity: {
      add: "پائالىيەت قوشۇش",
      addTheme: "添加模版",
      product: "مەھسۇلات قوشۇش",
      title: "پائالىيەت",
      zhImg: "خەنزۇچە رەسىم",
      ugImg: "ئۇيغۇرچە رەسىم",
      imgWarning: "رەسىم يوق",
      edit: "تەھرىرلەش",
      delete: "ئۆچۈرۈش",
      today: "بۈگۈن",
      start_date: "باشلىنىش",
      end_date: "ئاخىرلىشىش",
      addProduct: "مەھسۇلات قوشۇش",
      time: "پائالىيەت ۋاقتى",
      product_list: "مەھسۇلات تىزىملىكى",
      discount_price: "پائالىيەت باھاسى(يۈەن)",
      discountWarning: "پائالىيەت باھاسىنى كىرگۈزۈڭ",
      min: "ئەڭ تۆۋەن چەك",
      minWarning: "ئەڭ تۆۋەن چەكنى كىرگۈزۈڭ",
      max: "ئەڭ يۇقىرى چەك",
      maxWarning: "ئەڭ يۇقىرى چەكنى كىرگۈزۈڭ",
    },
    groupon: {
      title: "گۇرۇپپا سودا",
      deals: "تۈر باشقۇرۇش",
      orders: "زاكاز باشقۇرۇش",
      addDeal: "تۈر قوشۇش",
      editDeal: "تۈر تەھرىرلەش",
      deal: "تۈر",
      originalPrice: "ئەسلى باھا (يۈەن)",
      salePrice: "سېتىش باھا (يۈەن)",
      neededPoints: "كېرەكلىك جۇغلانما",
      neededPointsRequired: "جۇغلانما سانىنى كىرگۈزۈڭ",
      validDays: "كۈن سانى",
      includedItems: "ئىچكى تۈرلەر",
      addItem: "تۈر قوشۇش",
      points: "جۇغلانما",
      cash: "نەق پۇل",
      verify: "ئىشلىتىش",
      verified: "ئىشلىتىلدى",
      refund: "قايتۇرۇش",
      refunded: "قايتۇرۇلدى",
      enterToken: "ئىشلىتىش كودى",
      redeemToken: "ئىشلىتىش كودى",
      expiresAt: "ۋاقتى",
      statusPending: "پۇل تۆلەش كۈتۈۋاتىدۇ",
      statusPaid: "ئىشلىتىشكە تەييار",
      statusRedeemed: "ئىشلىتىلدى",
      statusRefunded: "قايتۇرۇلدى",
      statusLabel: {
        0: "پۇل تۆلەش كۈتۈۋاتىدۇ",
        1: "ئىشلىتىشكە تەييار",
        2: "ئىشلىتىلدى",
        3: "قايتۇرۇلدى",
        4: "بىكار قىلىندى",
      },
      zhName: "خەنزۇچە نام",
      ugName: "ئۇيغۇرچە نام",
      zhDescription: "خەنزۇچە چۈشەندۈرۈش",
      ugDescription: "ئۇيغۇرچە چۈشەندۈرۈش",
      sortOrder: "تەرتىپ",
      edit: "تەھرىرلەش",
      delete: "ئۆچۈرۈش",
      save: "ساقلاش",
      cancel: "بىكار قىلىش",
      back: "قايتىش",
      detail: "تەپسىلات",
      all: "ھەممىسى",
      search: "ئىزدەش",
      active: "ئېچىق",
    },
    nav: {
      add: "سەھىپە قوشۇش",
      title: "سەھىپە تەھرىرلەش",
      order: "تەرتىپى",
      orderPlace: "نۇمۇرى قانچە چوڭ بولسا شۇنچە ئالدىغا تىزىلىدۇ",
      target: "ئۇلىنىشى",
      targetWarning: "ئۇلىنىشىنى تاللاڭ",
      img: "رەسىمى",
      imgWarning: "رەسىم يوق",
      coupon: "ئېتىبار كارتىسى بېتى",
      product: "مەھسۇلات تۈرى بېتى",
      childTab: "سەھىپە",
      orders: "بارلىق زاكازلار بېتى",
      discount: "ئالاھىدە باھالىق بېتى",
      liveList: "نەق مەيدان تىزىملىك بېتى",
      liveRoom: "نەق مەيدان ئۆيى",
      mediaUrl: "فىلىم ئادىرىسىنى ئېلىش",
      roomId: "ئۆي نومۇرى",
      roomIdWarning: "ئۆي نومۇرىنى كىرگۈزۈڭ",
      couponIdWarning: "ئېتىبار كارتىسىنى تاللاڭ",
      imgTip:
        "باش بەتتىكى سىيرىلما ئېلاننىڭ ئاستىدىكى سەھىپە تىزىملىكى، تەگلىكسىز رەسىم قوللايدۇ، رازمېرى 300px*300px",
      showText: "تېكىست كۆرسەت",
      iconHeight: "سىنبەلگە ئۇزۇنلۇقى",
      iconHeightPlace: "سىنبەلگە ئۇزۇنلۇقىنى كىرگۈزۈڭ (پىكسېل)",
    },
    mini: {
      name: "ئەپچاق ئىسمى",
      shortName: "قىسقارتىلما ئىسمى",
      description: "چۈشەندۈرۈلىشى",
      img: "باش رەسىم",
      primary: "باش رەڭ",
      secondary: "يانداش رەڭ",
      testTitle: "سىناق تىما",
      testBtnTitle: "سىناق كونۇپكا",
      nameWarning: "ئىسمىنى تولدۇرۇڭ",
      appIdWarning: "AppId نى تولدۇرۇڭ",
      appSecretWarning: "AppSecret نى تولدۇرۇڭ",
      tokenWarning: "Token نى تولدۇرۇڭ",
      aesKeyWarning: "AESKey نى تولدۇرۇڭ",
      descriptionWarning: "ئەپچاقنىڭ چۈشەندۈرىلىشىنى تولدۇرۇڭ",
      imgWarning: "ئەپچاقنىڭ باش رەسىمىنى يوللاڭ",
      mainConfig: "ئەپچاق سەپلىمىسى",
      secondConfig: "ئەپچاق تەڭشىكى",
      paymentConfig: "پۇل تۆلەش تەڭشىكى",
      zhTitle: "خەنزۇچە تېمىسى",
      ugTitle: "ئۇيغۇرچە تېمىسى",
      language: "باش تىلى",
      live: "نەق مەيدان",
      ug: "ئۇيغۇرچە",
      zh: "خەنزۇچە",
      theme: "ئۇسلۇبى",
      dark: "قاراڭغۇ",
      light: "يورۇق",
      navBarBgColor: "باش تەرەپ تەگلىك رەڭ",
      navBarTextColor: "باش تەرەپ خەت رەڭگى ",
      settingWarning:
        "ئەپچاق سەپلىمىسىنى تولدۇرۇپ مۇۋەپپەقىيەتلىك تاپشۇرغاندىن كىيىن، ئاندىن تەڭشەكنى تەڭشەڭ",
    },
    coupons: {
      add: "ئېتىبار كارتىسى قوشۇش",
      send: "تارقىتىش",
      title: "ئېتىبار كارتىسىنى تەھرىرلەش",
      price: "ئېتىبار سوممىسى (يۈەن)",
      limit: "قانچىگە توشسا (يۈەن)",
      range: "ئېلىۋېلىش ۋاقتى",
      experation: "ئىناۋەتلىك ۋاقتى",
      expireDays: "ئېلىۋالغاندىن كېيىنكى كۈن سانى",
      expireDaysUnit: "كۈن",
      expireDaysHint: "ئىشلەتكۈچى ئېلىۋالغاندىن كېيىن شۇ كۈن سانى ئىچىدە ئىشلىتىشكە بولىدۇ",
      expireDaysWarning: "ئىناۋەتلىك كۈن سانىنى تولدۇرۇڭ",
      claimLimit: "ھەر بىر ئىشلەتكۈچى ئېلىش چەكلىمىسى",
      claimLimitHint: "0 = چەكسىز",
      claimLimitWarning: "ئېلىش چەكلىمىسىنى تولدۇرۇڭ",
      usageNoticeZh: "ئىشلىتىش چۈشەندۈرۈشى (خەنزۇچە)",
      usageNoticeUg: "ئىشلىتىش چۈشەندۈرۈشى (ئۇيغۇرچە)",
      priceWarning: "ئېتىبار سوممىسىنى تولدۇرۇڭ",
      limitWarning: "زاكاز سوممىسىنى تولدۇرۇڭ",
      rangeWarning: "ئېلىۋىلىش ۋاقتىنى تاللاڭ",
      experationWarning: "ئىناۋەتلىك ۋاقتىنى تاللاڭ",
      select: "تاللاش",
      selected: "تاللاندى",
      quantity: "سانى",
      quantityWarning: "كارتا سانىنى تولدۇرۇڭ",
      status: "ھالىتى",
      total: "%{count} تال بار",
      left: "%{count} تال قالدى",
      start: "%{price} يۈەنگە توشسا",
      face_price: "%{price} يۈەن ئېتىبار",
      no_limit: "توسالغۇسىز",
      all: "ھەممىسى",
      used: "ئىشلىتىپ بولغان",
      unused: "ئىشلەتمىگەن  ",
      distributedDate: "تارقىتىلغان ۋاقتى:",
      distributedList: "تارقىتىش تارىخى",
      duplicate: "كۆچۈرۈش",
      duplicateTitle: "ئېتىبار كارتىسىنى كۆچۈرۈش",
      duplicateNameSuffix: " (كۆچۈرۈلمە)",
      usedDate: "ئىشلەتكەن ۋاقتى:",
      orderNo: "زاكاز نومۇرى",
      isPublic: "ئاممىباپمۇ؟",
      selectedCount: "%{count} تال تاللاندى",
      showAllSelected: "ھەممىسىنى كۆرۈش (%{count})",
    },
    gift: {
      add: "سوۋغات قوشۇش",
      edit: "تەھرىرلەش",
      product: "مەھسۇلاتقا",
      order: "زاكاز سوممىسىغا",
      type: "سوۋغات تىپى",
      orderAmount: "زاكاز سوممىسى",
      selected: "تاللانغىنى",
      deleteAll: "ھەممىنى ئۆچۈرۈش",
      rangeWarning: "ۋاقتىنى تاللاڭ",
      gift: "سوۋغات",
      typeWarning: "سوۋغات تىپىنى تاللاڭ",
    },
  },
  property: {
    addChild: "ئۆلچەم قوشۇش",
    delete: "ئۆلچەم گورۇپپىسىنى يۇيۇش",
    addGroup: "ئۆلچەم گورۇپپىسى قوشۇش",
    newGroup: "يېڭى ئۆلچەم گورۇپپىسى",
    selectGroup: "ئۆلچەم گۇرۇپپىسى تاللاڭ",
    submit: "مۇقىملاش",
    groupZh: "گورۇپپىسىنىڭ خەنزۇچە ئىسمى",
    groupUg: "گورۇپپىسىنىڭ ئۇيغۇرچە ئىسمى",
    childZh: "ئۆلچەمنىڭ خەنزۇچە ئىسمى",
    childUg: "ئۆلچەمنىڭ ئۇيغۇرچە ئىسمى",
    number: "مەھسۇلات نومۇرى",
    priceYuan: "باھا (يۈەن)",
    priceYuanPlaceholder: "يۈەن",
    quantity: "ئامبار سانى",
    must: "چوقۇم تولدۇرۇڭ",
    deleteGroup:
      "بۇنى ئۆچۈرسىڭىز، بۈ تۈرگە كىرگۈزگەن خاسلىق ئۇچۇرىلىرى تەڭ ئۆچۈپ كېتىدۇ راستىنلا داۋاملاشتۇرامسىزئ؟",
    priceWarning: "باھاسىنى كىرگۈزڭ",
    quantityWarning: "سانىنى كىرگۈزۈڭ",
    bulkFill: "توپلىما كىرگۈزۈش، Enter بېسىڭ",
  },
  payment: {
    merchantId: "سودىگەر نومۇرى",
    secret: "سودىگەر ئاچقۇچى",
  },
  agentLevel: {
    add: "سەۋىيە قوشۇش",
    zh: "خەنزۇچە ئىسمى",
    ug: "ئۇيغۇرچە ئىسمى",
    commission: "كومىسسىيە",
    product: "مۇناسىۋەتلىك مەھسۇلات",
    title: "ۋەكىل سەۋىيىسى كومىسسىيە تەڭشىكى",
    selectLevels: "دەرىجىنى تاللاش",
    commissionSettings: "كومىسسىيە تەڭشىكى",
    selectLevel: "دەرىجىنى تاللاڭ",
    selectLevelWarning: "دەرىجىنى تاللاڭ",
    commissionWarning: "پايدىسىنى كىرگۈزۈڭ",
    commissionRangeWarning: "كومىسسىيە 0-100 ئارىلىقىدا بولۇشى كېرەك",
    commissionPlaceholder: "پايدىسىنى كىرگۈزۈڭ",
    parentCommission: "يېتەكچى پايدىسى",
    parentCommissionWarning: "يېتەكچى پايدىسىنى كىرگۈزۈڭ",
    parentCommissionPlaceholder: "يېتەكچى پايدىسىنى كىرگۈزۈڭ",
    alreadySet: "تەڭشەلگەن",
    noCommissions: "كومىسسىيە تەڭشىكى يوق",
    addSuccess: "كومىسسىيە تەڭشىكى مۇۋەپپەقىيەتلىك قوشۇلدى",
    updateSuccess: "كومىسسىيە تەڭشىكى مۇۋەپپەقىيەتلىك يېڭىلاندى",
    deleteWarning: "بۇ كومىسسىيە تەڭشىكىنى ئۆچۈرگەندە ئىشەنچىلىك مۇ؟",
  },
  users: {
    select: "ئەزا تاللاش",
    name: "ئىسمى",
    avatar: "باش سۈرىتى",
    tags: "تىزىملاتقانمۇ",
    actions: "مەشغۇلات",
    unbind: "ئۈندىدار يېشىش",
    registered: "تىزىملاتقان",
    unregistered: "تىزىملاتمىغان",
    order: "زاكاز سانى",
    searchPlace: "ئەزا ئىسمى ياكى تېلفون نومۇرىنى كىگۈزۈپ ئىزدەڭ",
    balance: "قالدۇقى",
    balanceSum: "ئومومىي قالدۇق: ",
    date: "كىرگەن ۋاقتى",
    unbindWarning: "باغلاقتىن يېشەمسىز؟",
    currentBalance: "ھازىرقى قالدۇقى",
    topup: "پۇل تولۇقلاش",
    topupWarning: "مۇشۇ ئەزاغا پۇل قاچىلامسىز؟",
    recall: "بىكار قىلىش",
    recallWarning: "بىكار قىلامسىز؟",
    operator: "مەشغۇلاتچى",
    appoint: "بەلگىلەش",
    unappoint: "بەلگىنى ئۆچۈرۈش",
    confirmReducing: "راستىنلا ئۆزگەرتەمسىز",
    reduceAmount: "سومىسى",
    reduceComment: "ئەسكەرتىش (بانكا پۇل ئۇرۇش نومۇرى، چېسلا دېگەندەك)",
    columnRequired: "بۇ ئۇچۇرنى چوقۇم تولدۇرىشىڭىز كېرەك",
  },
  live: {
    edit: "نەق مەيدان ئۆيىنى تەھرىرلەش",
    sync: "ماس قەدەملەش",
    ugTitle: "ئۇيغۇرچە تېمىسى",
    zhTitle: "خەنزۇچە تېمىسى",
    order: "تەرتىپى",
    zh_poster_image: "خەنزۇچە ئېلان رەسىمى",
    ug_poster_image: "ئۇيغۇرچە ئېلان رەسىمى",
    rec: "تەۋسىيەلەنگەن",
    zh_recommanded: "خەنزۇچە تەۋسىيە رەسىم",
    ug_recommanded: "ئۇيغۇرچە تەۋسىيە رەسىم",
  },
  deliveryman: {
    title: "توشۇغۇچى باشقۇرۇش",
    add: "توشۇغۇچى قوشۇش",
    edit: "توشۇغۇچى تەھرىرلەش",
    zhNameHint: "توشۇغۇچى خەنزۇچە ئىسمىنى تولدۇرۇڭ",
    zhName: "خەنزۇچە ئىسمى",
    ugNameHint: "توشۇغۇچى ئۇيغۇرچە ئىسمىنى تولدۇرۇڭ",
    ugName: "ئۇيغۇرچە ئىسمى",
    mobile: "تېلېفۇن نومۇرى",
    mobileHint: "تېلېفۇن نومۇرىنى توغرا كىرگۈزۈڭ",
    mobileHolder: "تېلېفۇن نومۇرىنى كىرگۈزۈڭ",
    deleteWarning: "راستىنلا ئۆچۈرەمسىز؟",
    atleast: "باغلايدىغان مەھەللىدىن بىرنى تاللاڭ",
  },
  community: {
    title: "رايون باشقۇرۇش",
    edit: "رايون ئۇچۇرىنى تەھرىرلەش",
    add: "رايون قوشۇش",
    zhNameHint: "خەنزۇچە نامىنى كىرگۈزۈڭ",
    zhName: "خەنزۇچە نامى",
    ugNameHint: "ئۇيغۇرچە نامىنى كىرگۈزۈڭ",
    ugName: "ئۇيغۇرچە نامى",
    zhAddress: "خەنزۇچە ئ‍ادرېسىنى كىرگۈزۈڭ",
    zhAddress: "خەنزۇچە ئادرېسى",
    ugAddressHint: "ئۇيغۇرچە ئادرېسىنى كىرگۈزۈڭ",
    ugAddress: "ئۇيغۇرچە ئ‍ادرېسى",
    position: "كوردىناتى",
    positionHint: "كوردىناتىنى تولدۇرۇڭ",
    population: "ئاھالە سانى",
    order: "تەرتىپى",
    addMany: "تۈركۈملەپ قوشۇش",
    polygon: "رايون تاللاش",
    success: "مەھەللە مۇۋەپپەقىيەتلىك قېتىلدى",
  },
  deliveryZone: {
    title: "يەتكۈزۈش رايونى ۋە ھەققى",
    pageHint:
      "قاتلام بويىچە يەتكۈزۈش رايونى سىزىڭ: 1-قاتلام ئەڭ ئىچكى قەۋەت. ئىشلەتكۈچى قايسى قاتلامدا بولسا شۇ قاتلامنىڭ يەتكۈزۈش ھەققى ھېسابلىنىدۇ؛ ھېچقانداق قاتلامدا بولمىسا زاكاز چۈشۈرگىلى بولمايدۇ.",
    add: "يەتكۈزۈش قاتلىمى قوشۇش",
    edit: "يەتكۈزۈش قاتلىمىنى تەھرىرلەش",
    level: "قاتلام",
    levelHint: "قاتلامنى تولدۇرۇڭ (1 ئەڭ ئىچكى)",
    levelHintNested:
      "ئالدى بىلەن ئىچكى رايوننى، ئاندىن چوڭراق تاشقى رايوننى سىزىڭ؛ سان قانچە كىچىك بولسا دۇكانغا شۇنچە يېقىن.",
    zhName: "خەنزۇچە نامى",
    zhNameHint: "ئىختىيارىي",
    ugName: "ئۇيغۇرچە نامى",
    ugNameHint: "ئىختىيارىي",
    isFree: "ھەقسىز يەتكۈزۈش",
    free: "ھەقسىز",
    shipPrice: "يەتكۈزۈش ھەققى",
    shipPriceHint: "يەتكۈزۈش ھەققىنى تولدۇرۇڭ (يۈەن)",
    startingPrice: "باشلىنىش باھاسى",
    startingPriceHint: "باشلىنىش باھاسىنى تولدۇرۇڭ (يۈەن)",
    startingPriceExtra:
      "بۇ قاتلامدىكى دۇكانلار زاكاز سوممىسى بۇ باھاغا يەتكەندە زاكاز چۈشۈرەلەيدۇ. پۈتۈن سېتىشتا دۇكان تەستىق ئورنى بويىچە قاتلام تاللىنىدۇ.",
    enabled: "قوزغىتىش",
    enabledOn: "قوزغىتىلغان",
    enabledOff: "توختىتىلغان",
    boundary: "يەتكۈزۈش چېگراسى",
    boundaryRequired: "چېگرا سىزىڭ (كەم دېگەندە 3 نۇقتا)",
    startDrawing: "سىزىشنى باشلاش",
    finishDrawing: "سىزىشنى تاماملاش",
    clear: "چېگرىنى تازىلاش",
    pointCount: "نۇقتا سانى: %{count}",
    drawingHint:
      "خەرىتىدە نۇقتىلارنى بېسىپ كۆپ بۇلۇڭلۇق سىزىڭ، ئاندىن «سىزىشنى تاماملاش» نى بېسىڭ.",
    idleHint: "«سىزىشنى باشلاش» نى بېسىپ بۇ قاتلامنىڭ يەتكۈزۈش دائىرىسىنى سىزىڭ.",
    minPoints: "چېگرا ئۈچۈن كەم دېگەندە 3 نۇقتا كېرەك",
    deleteWarning: "بۇ يەتكۈزۈش قاتلىمىنى راستىنلا ئۆچۈرەمسىز؟",
  },
  merchantLocation: {
    title: "دۇكان ئورنى",
    pageHint:
      "دۇكاننىڭ خەرىتە ئورنىنى بەلگىلەڭ. بۇ كوردىنات يەتكۈزۈش دائىرىسىنىڭ مەركىزى ۋە ئىشلەتكۈچى تەرەپتە ئورۇن تاللىغاندا خەرىتە مەركىزى بولۇپ ئىشلىتىلىدۇ.",
    coordinate: "كوردىنات",
    coordinateHint: "ئىناۋەتلىك كوردىنات تولدۇرۇڭ، فورماتى: ئۇزۇنلۇق,كەڭلىك",
    mapHint: "خەرىتىنى بېسىپ كوردىنات تاللاڭ، ياكى ئۈستىگە ئۇزۇنلۇق,كەڭلىك كىرگۈزۈڭ",
    mapLoadFailed: "خەرىتە يۈكلەش مەغلۇپ بولدى، قايتا سىناڭ",
  },
  appearance: {
    title: "ئۇسلۇب ۋە رەڭ",
    pageHint:
      "ئەپچاق تېما رەڭگى ۋە ئۇسلۇبنى تەڭشەڭ؛ كىچىك پروگرامما ياكى چىقىم تەڭشىكى تولدۇرۇش ھاجەتسىز.",
    preview: "ئالدىن كۆرۈش",
  },
  communityBuilding: {
    title: "بىنا باشقۇرۇش",
    manage: "بىنا",
    edit: "بىنا تەھرىرلەش",
    add: "بىنا قوشۇش",
    zhName: "خەنزۇچە نامى",
    ugName: "ئۇيغۇرچە نامى",
    zhNameHint: "خەنزۇچە بىنا نامىنى كىرگۈزۈڭ",
    ugNameHint: "ئۇيغۇرچە بىنا نامىنى كىرگۈزۈڭ",
    enabled: "قوزغىتىش",
    enabledYes: "قوزغىتىلغان",
    enabledNo: "توختىتىلغان",
  },
  lottery: {
    title: "چەك تارتىش پائالىيىتى",
    wheel: "چاقپەلەك",
    nine: "ئايلانما چىراق",
    fruit: "يولۋاس ماشىنىسى",
    product: "مەھسۇلات",
    coupon: "ئېتىبار كارتىسى",
    thirdAppCoupon: "باشقا ئەپچاق ئېتىبار كارتىسى",
    red: "قىزىل بولاق",
    thanks: "رەھمەت",
    itemType: "مۇكاپات تۈرى",
    itemTypeWarning: "مۇكاپات تۈرىنى تاللاڭ",
    percent: "ئ‍ىھتىماللىقى",
    remainError: "يەنە %{remain} قالدى",
    percentMessage: "ئىھتىماللىقىنىڭ يىغىندىسى چوقۇم 100 پىرسەنت بولۇشى كىرەك",
    add: "مۇكاپات قوشۇش",
    type: "مۇكەپات تارتىش شەكلى",
    empty: "مۇكاپات قوشۇڭ",
    redWarning: "قىزىل بولاق سوممىسىنى تولدۇرۇڭ",
    prizes: "مۇكاپاتلار",
    prirzeTotal: "تارقىتىلغان سانى",
    wheelWarning: "چاخپىلەكتە چوقۇم ئالتە مۇكاپات بولۇشى كىرەك",
    fruitWarning: "مىۋە ماشىنىسىدا چوقۇم سەككىز مۇكاپات بولۇشى كىرەك",
    themeWarning: "مۇكاپات ئۇسلۇبىنى تاللاڭ",
    validTime: "ئىناۋەتلىك ۋاقتى",
    validWarning: "ئىناۋەتلىك ۋاقتىنى تولدۇرۇڭ",
    validRule:
      "مۇكاپاتقا ئېرىشكەن كۈندىن باشلاپ ھىساپلىنىدۇ، ئۆتۈپ كەتسە مۇكاپات ئىناۋەتسىز",
    ticketCount: "بىلەت سانى",
    recommendCount: "سېتىلغان سانى",
    recommendAmount: "سېتىلغان سوممىسى",
    recommendCommission: "تاپقان پۇلى",
    recommendList: "تەشۋىقات ئەھۋالى",
    currentCount: "بىلەت سانى خاتىرىسى",
    prizeCount: "مۇكاپات خاتىرىسى",
    transCount: "يۆتكىلىش خاتىرىسى",
    reduce: "بىلەت ئازلىتىش",
    revert: "قايتۇرۇش",
    zhStartImg: "باشلاش كونۇپكىسى (خەنزۇچە)",
    ugStartImg: "باشلاش كونۇپكىسى (ئۇيغۇرچە)",
    zhHeaderImg: "پائالىيەت تېمىسى (خەنزۇچە)",
    ugHeaderImg: "پائالىيەت تېمىسى (ئۇيغۇرچە)",
    plateBack: "تەخسە تەگلىكى",
    ugDesc: "چۈشەندۈرۈلىشى (ئۇيغۇرچە)",
    zhDesc: "چۈشەندۈرۈلىشى (خەنزۇچە)",
    zhAwardImg: "مۇكاپات رەسىمى (خەنزۇچە)",
    ugAwardImg: "مۇكاپات رەسىمى (ئۇيغۇرچە)",
    thumb: "ئۇسلۇب رەسىمى",
    zhImg: "باش بەت تەگلىك رەسىمى (خەنزۇچە)",
    ugImg: "باش بەت تەگلىك رەسىمى (ئۇيغۇرچە)",
    backColor: "باش بەت تەگلىك رەڭگى",
    imgRule: "رەسىنىڭ رازمېرى %{pixel} تىپى %{type} بولسا بولىدۇ",
    backColorRule: "تەگلىك رەسىمنىڭ رەڭگى ئېلىنسا ياخشى چىقىدۇ",
    sender: "تارقاتقۇچى",
    receiver: "تاپشۇرۇۋالغۇچى",
    telWarning: "تېلېفۇن نومۇرىنى كىرگۈزڭ",
    receiverWarning: "ئىسمىنى كىرگۈزڭ",
    addressWarning: "ئادرېسىنى تولۇق كىرگۈزڭ",
    drew_at: "مۇكاپات تارتقان ۋاقىت",
    exchanged_at: "ئالماشتۇرغان ۋاقىت",
    prize: "مۇكاپات",
    draw: "مۇكاپات تارتقىنى",
    exchange: "تىگىشىپ بولغىنى",
    organSend: "ئورگان تارقاتقىنى",
    userTickets: "ئەزالارنىڭ قولىدىكى",
    ticketPrice: "بىلەت باھاسى (يۈەن)",
    ticketWarning: "بىلەت باھاسىنى كىرگۈزۈڭ",
    toExchange: "نەقلەش",
    exchangeAlert: "نەقلەمسىز؟",
    selfBuy: "خېرىدار بىلەت سېتىۋالالامدۇ؟",
    onSite: "مۇكاپاتنى دۇكاندا ئالامدۇ؟",
    selfBuyCount: "ئۆزى سېتىۋالغان",
    buyHistory: "بىلەت سېتىۋىلىش تارىخى",
    select: "تاللاش",
    left: "ئېشىپ قالغىنى",
    prePrice: "ئالدىن بەلگىلەش",
    addPrePrize: "يېىدىن قوشۇش",
    selectManager: "باشقۇرغۇچىنى تاللاڭ",
    managers: "باشقۇرغۇچىلار",
    opened: "ئوچۇق",
  },
  redPacket: {
    zhImg: "قىزىل بولاق (خەنزۇچە)",
    ugImg: "قىزىل بولاق (ئۇيغۇرچە)",
    price: "(يۈەن)قىممىتى",
    count: "ئادەم سانى",
    add: "قىزىل بولاق قوشۇش",
    update: "تەھرىرلەش",
    atLeast: "ئەڭ ئاز دىگەندە %{price} يۈەن لازىم",
    priceWarning: "سوممىسىنى كىرگۈزۈڭ",
    countWarning: "ئادەم سانىنى كىرگۈزۈڭ",
    list: "خاتىرىسى",
    user: "ئېرىشكۈچى",
    retry: "قايتا ھاسىللاش",
  },
  article: {
    add: "ماقالە قوشۇش",
    addCatPlz: "ئاۋۋال ماقالە تۈرى قوشۇڭ",
    cat: "ماقالە تۈرى",
    title: "ماقالە",
    all: "ھەممىسى",
    opened: "ئېچىقلىق",
    closed: "تاقاقلىق",
    selectWarning: "ماقالىنى تاللاڭ",
    tags: "بەلگە",
    tagsPlaceholder: "بەلگە تاللاڭ",
    tagAdd: "بەلگە قوشۇش",
    tagEdit: "بەلگە تەھرىرلەش",
    editorsChoiceAdd: "بۈگۈنلۈك سۆز قوشۇش",
    showOnDate: "كۆرسىتىش چېسلاسى",
    showOnDateRequired: "كۆرسىتىش چېسلاسىنى تاللاڭ",
    zhComment: "خەنزۇچە تەھرىر بايانى",
    ugComment: "ئۇيغۇرچە تەھرىر بايانى",
    commentRequired: "تەھرىر بايانىنى تولدۇرۇڭ",
    video: "فىلىم (ئىختىيارى)",
    videoUrl: "فىلىم (ئىختىيارى)",
    defaultViews: "سۈنئىي ئوقۇش سانى",
    realViews: "ھەقىقىي ئوقۇش سانى",
  },
  weapp: {
    add: "يېڭى نەشىر يوللاش",
    version: "نەشرى",
    type: "تىپى",
    build: "zip ھۆججىتى",
    standard: "ئۆلچەملىك",
    lottery: "مۇكاپاتلىق",
    course: "دەرسخانا",
    drag: "zip ھۆججىتىنى تاللاڭ ياكى تارتىپ مۇشۇ رايونغا ئەكىرىڭ",
  },
  transfer: {
    new: "پۇل ئۇرۇش",
    reason: "ئىزاھاتىنى يېزىڭ",
  },
  applyment: {
    apply: "ئىلتىماس",
    applyAgain: "قايتا ئىلتىماس",
    query: "تەكشۈرۈش",
    applyDescription:
      "1.ئ‍ىجازەت ئۇچۇرىنى يوللاڭ \n 2. بانكا ئۇچۇرىنى يوللاڭ \n 3. تىجارەت ئۇچۇرىنى يوللاڭ \n 4.ئ‍ەڭ ئاخىرقى باسقۇچ",
    procesing: "بىر تەرەپ قىلىنىۋاتىدۇ",
    processingDescription: "",
    finishDescription: "",
    title: "ئۈندىدار پۇل تۆلەش سىستېمىسىغا ئىلتىماس قىلىش",
    id: "ئىلتىماس نومۇرى",
    status: "ئىلتىماس ھالىتى",
    merchantId: "دۇكان نومۇرى",
    subMerchantId: "ئۈندىدار دۇكان نومۇرى",
    createdDate: "ئىلتىماس قىلىنغان ۋاقىت",
    updatedDate: "يېڭىلانغان ۋاقىت",
    check: "تەكشۈرۈش",
    checking: "ماتېرياللار تەكشۈرىلىۋاتىدۇ",
    accountNeedVerify: "بانكا ھېساباتى دەلىللنىشى كېرەك",
    auditing: "تەستىقلىنىۋاتىدۇ",
    rejected: "رەت قىلىندى",
    canceled: "قالدۇرۇلغان",
    needSign: "كېلىشىم باسقۇچى",
    needSignHint: "مەسئۇل خادىم ئۈندىداردا كودنى سكان قىلىپ كېلىشىمگە ئىمزا قويۇڭ",
    finish: "تاماملاندى",
    frozen: "توڭلىتىلدى",
    otherAccountsHeading: "باشقا ئۈندىدار تۆلەش دۇكىنى ئىلتىماسلىرى",
  },
  member: {
    memberType: "ئەزالىق شەكلى",
    courseMember: "دەرسلىك ئەزالىقى",
    allMember: "ئ‍ەپچاق ئەزالىقى",
    info: "ئەزا ئۇچۇرى",
    number: "ئەزا نومۇرى",
    joined_at: "ئەزا بولغان",
    expired_at: "توشۇدىغان ۋاقتى",
    saved: "تىجەلگىنى (يۈەن)",
    add: "يېڭى ئەزا قوشۇش",
    remove: "ئەزانى چىقىرىۋېتىش",
    removeConfirm: "بۇ ئابونتنى ئەزالار تىزىملىكىدىن چىقىرىۋېتەمسىز؟",
    removed: "ئەزالىقتىن چىقىرىۋېتىلدى",
    filterMobile: "يانفون نومۇرى",
    filterMobileHint: "يانفون نومۇرىنى كىرگۈزۈڭ",
    filterKeyword: "ئاچقۇچ سۆز",
    filterKeywordHint: "نام كېلىشى مۇمكىن (backend قوللايدىغان بويىچە)",
    filterMemberNo: "ئەزا نومۇرى",
    filterMemberNoHint: "ئەزا نومۇرى",
    filterMemberCard: "ئەزالىق كارتىسى",
    filterMemberCardPlaceholder: "بارلىق كارتىلار",
    filterCreatedAtRange: "قۇرۇلغان ۋاقىت",
    filterLast7Days: "ئاخىرقى 7 كۈن",
    filterLast30Days: "ئاخىرقى 30 كۈن",
    searchFilters: "ئىزدەش",
    resetFilters: "ئەسلىگە قايتۇرۇش",
    duration: "مۇددىتى",
    type: "ئەزا تىپى",
    user: "ئالىي ئەزا",
    selectUser: "ئابونتنى تاللاش",
    reselect: "قايتا تاللاش",
    durationWarning: "مۇددەتنى تاللاڭ",
    cardWarning: "ئەزا تىپىنى تاللاڭ",
    zhDesc: "خەنزۇچە",
    ugDesc: "ئۇيغۇرچە",
    price: "ئەزا ھەققى",
    points: "جۇغلانما",
    discount: "ئېتىبار",
    multiple: "جۇغلانما ھەسسىلىكى",
    addCard: "ئەزا كارتىسى قوشۇش",
    editCard: "ئەزا كارتىشى تەھرىرلەش",
    autoGrantOnFirstOrderTitle: "تۇنجى زاكازدىن كېيىن ئاپتوماتىك ئەزالىق كارتا",
    autoGrantOnFirstOrderHint:
      "خېرىدار تۇنجى قېتىم مەھسۇلات زاكازىغا پۇل تۆلىگەندىن كېيىن ئاپتوماتىك ئەزا بولىدۇ؛ بۇ تۇنجى زاكازغا ئەزا ئېتىبارى قىلىنمايدۇ، ئىككىنچى زاكازدىن باشلاپ ئېتىبار بولىدۇ. ۋاكالەتچى ئۆزى سېتىۋالسا ۋاكالەتچى ئېتىبارى ئالدىن تۇرىدۇ. بوش قالسا ئېچىلمايدۇ.",
    autoGrantOnFirstOrderPlaceholder: "بېرىدىغان ئەزالىق كارتىنى تاللاڭ",
    paidAt: "پۇل تۆلىگەن ۋاقتى",
    independentCommission: "ئايرىم پايدا ئ‍ايرىش ئۇچۇرى تەڭشەمسىز",
    memberAdventages: "ئەزا ھوقوقى",
    shouldAllCourseFree: "ھەممە دەرىسنى ھەقسىز كۆرەمدۇ؟",
    shouldAllCourseFreeDescription:
      "بۇ ئىقتىدار ئېچىۋىتىلگەندىن كېيىن، خېرىدار بۇ ئەزالىق ھوقوقىنى سېتىۋالسا، دەرىسلەرنى ھەقسىز كۆرەلەيدۇ",
    discountDescription:
      "ئەپچاقتى مال سېتىۋىلىنسا بەھرىمان بولىدىغان ئېتىبار، مەسىلەن 10% دەپ تولدۇرۇلسا، ئەسلى باھاسىدىن 10% تۆۋەن ئالالايدۇ.",
    multiplePointsDescription:
      "ئەگەر جۇغلانما ئېقتىدارىنى ئېچىۋەتكەن بولسىڭىز، خېرىدار ھەربىر يۈەن خەجلىسە بىر نومۇر قېتىلىپ ماڭىدۇ.",
    giftCodes: {
      title: "ئەزا سوۋغات كودى پائالىيىتى",
      docReference:
        "API چۈشەندۈرۈشى ئامباردىكى docs/member-gift-codes-api.md ھۆججىتىدە (دۇكان API).",
      batchNumber: "تۈر نومۇرى",
      batchNumberRequired: "تۈر نومۇرىنى كىرگۈزۈڭ",
      quantityRequired: "كود سانىنى كىرگۈزۈڭ",
      memberCard: "ئەزالىق كارتىسى",
      quantity: "كود سانى",
      status: "ھالەت",
      export: "چىقىرىش ھۆججىتى",
      statusUnknown: "نامەلۇم",
      statusCreated: "لايىھە (تەھرىرلىگىلى بولىدۇ)",
      statusGeneratingCodes: "كود ھاسىللىنىۋاتىدۇ",
      statusGeneratedCodes: "كود تەييار",
      statusGeneratingExcel: "Excel چىقىرىلىۋاتىدۇ",
      statusGeneratedExcel: "چىقىرىش تامام",
      createActivity: "يېڭى پائالىيەت",
      editActivity: "تەھرىرلەش",
      codesTitle: "ئالماشتۇرۇش كودلىرى",
      codeValue: "كود",
      userId: "ئىشلەتكۈچى ID",
      redeemedAt: "ئالماشتۇرۇش ۋاقتى",
      filterKeyword: "كود بويىچە ئىزدەش",
      filterRedeemed: "ئالماشتۇرۇش ھالىتى",
      filterRedeemedYes: "ئالماشتۇرۇلغان",
      filterRedeemedNo: "ئالماشتۇرۇلمىغان",
      applyFilters: "سۈزگۈچ",
      refreshList: "تىزىمنى يېڭىلاش",
      autoRefresh: "ھەر 5 سېكۇنتتا ئاپتوماتىك يېڭىلاش",
      stopAutoRefresh: "ئاپتوماتىك يېڭىلىنىشنى توختىتىش",
      pollStarted: "ۋاقىتلىق يېڭىلاش قوزغىتىلدى",
      pollStopped: "ۋاقىتلىق يېڭىلاش توختىتىلدى",
      saveSuccess: "ساقلاندى",
      deleteSuccess: "ئۆچۈرۈلدى",
      deleteConfirm: "بۇ سوۋغات كودى پائالىيىتىنى ئۆچۈرەمسىز؟ پەقەت لايىھە ھالەتتە ئۆچۈرگىلى بولىدۇ.",
      onlyDraftEditable: "پەقەت لايىھە ھالەتتە تەھرىرلىگىلى بولىدۇ.",
      onlyDraftDeletable: "پەقەت لايىھە ھالەتتە ئۆچۈرگىلى بولىدۇ.",
      confirmGenerateCodes:
        "كود ھاسىللاش ۋەزىپىسى يوللىنىدۇ، داۋاملاشتۇرامسىز؟",
      confirmGenerateExcel:
        "Excel چىقىرىش ۋەزىپىسى يوللىنىدۇ، داۋاملاشتۇرامسىز؟",
      generateCodes: "كود ھاسىللاش",
      generateExcel: "Excel چىقىرىش",
      downloadExcel: "ھۆججەت چۈشۈرۈش",
      viewCodes: "كودلارنى كۆرۈش",
      jobQueued: "ۋەزىپە يوللاندى",
    },
  },
  media: {
    supportedImageType: "نۇسخىنى قوللايدۇ %{imageType}",
    supportedAudioType: "نۇسخىنى قوللايدۇ %{audioType}",
    supportedVideoType: "نۇسخىنى قوللايدۇ %{videoType}",
    fileName: "ھۆججەت نامى",
    upload: "يوللاش",
    fileInfo: "ھۆججەت ئۇچۇرى",
    size: "چوڭلۇقى",
    newFolder: "يېڭى مۇندەرىجە",
    folderName: "مۇندەرىجە نامى",
    rename: "ئىسمىنى ئۆزگەرتىش",
    addSubFolder: "بالا مۇندەرىجە قوشۇش",
    deleteFolder: "مۇندەرىجەنى ئۆچۈرۈش",
    selectedRows: "مەزمۇننى تاللىدىڭىز %{count}",
    saveFinished: "ساقلاش مۇۋەپپەقىيەتلىك بولدى",
    selectVideo: "فېلىم تاللاش",
    selectImages: "رەسىم تاللاش",
    selectAudio: "ئاۋاز تاللاش",
  },
  course: {
    title: "دەرىسلەر",
    otherTitle: "دەرىسكە مۇناسىۋەتلىك ئۇچۇرلار",
    titleArticle: "رەسىملىك دەرىسلەر",
    titleAudio: "ئاۋازلىق دەرىسلەر",
    titleVideo: "فىلىملىك دەرىسلەر",
    edit: "دەرىسنى تەھرىرلەش",
    add: "دەرىس قوشۇش",
    addArticle: "رەسىملىك دەرىس قوشۇش",
    addAudio: "ئاۋازلىق دەرىس قوشۇش",
    addVideo: "فىلىملىك دەرىس قوشۇش",
    editArticle: "رەسىملىك دەرىسنى تەھرىرلەش",
    editAudio: "ئاۋازلىق دەرىسنى تەھرىرلەش",
    editVideo: "فىلىملىك دەرىسنى تەھرىرلەش",
    basicInfo: "ئاساسىي ئۇچۇر",
    saleInfo: "سېتىۋىلىش ئۇسۇلى",
    commissionInfo: "پايدا ئ‍ايرىش",
    otherInfo: "باشقا ئۇچۇرلار",
    ugName: "دەرىس نامى (ئۇيغۇرچە)",
    name: "دەرىس نامى",
    zhName: "دەرىس نامى (خەنزۇچە)",
    ugSubTitle: "قسقىچە تونۇشتۇرلىشى (ئۇيغۇرچە)",
    zhSubTitle: "قسقىچە تونۇشتۇرلىشى (خەنزۇچە)",
    selectTeacher: "مۇئەللىمنى تاللاش",
    selectCategory: "تۈرىنى تاللاش",
    goToTeachers: "مۇئەللىم تاللاش",
    goToCategories: "تۈر تاللاش",
    ugBrief: "سىناپ كۆرۈش (ئۇيغۇرچە)",
    zhBrief: "سىناپ كۆرۈش (خەنزۇچە)",
    ugDescription: "دەرىس تەپسىلاتى (ئۇيغۇرچە)",
    zhDescription: "دەرىس تەپسىلاتى (خەنزۇچە)",
    ugAntiFraudDescription: "ئالدامچىلىققا قارشى چۈشەندۈرۈش (ئۇيغۇرچە)",
    zhAntiFraudDescription: "ئالدامچىلىققا قارشى چۈشەندۈرۈش (خەنزۇچە)",
    defaultView: "كۆرۈلىشى",
    actualView: "ھەقىقى كۆرۈلىشى",
    defaultSold: "سېتىلىشى",
    actualSold: "ھەقىقى سېتىلىشى",
    marketPrice: "بازار نەرقى",
    price: "باھاسى",
    notForSale: "سېتىلمايدۇ",
    forSale: "سېتىلىدىغان",
    saleTypeFilter: "سېتىش تۈرى",
    status: "ھالەت",
    statusActive: "جازىغا چىقىرىش",
    statusInActive: "توختاپ تۇرۇش",
    commissionPercent: "پايدا نىسبىتى",
    parentCommissionPercent: "ئاتا ۋاكالەتچىنىڭ پايدا نىسبىتى",
    validDate: "ئىناۋەتلىك ۋاقىت",
    validForever: "ئۇزاققىچە ئىناۋەتلىك",
    validDays: "سېتىۋالغاندىن كېيىنكى ئىناۋەتلىك كۈن سانى",
    cover: "دەرىس مۇقاۋىسى",
    zhCover: "دەرىس مۇقاۋىسى (خەنزۇچە)",
    ugCover: "دەرىس مۇقاۋىسى (ئۇيغۇرچە)",
    zhPortraitCover: "دەرىس تىك مۇقاۋىسى (خەنزۇچە)",
    ugPortraitCover: "دەرىس تىك مۇقاۋىسى (ئۇيغۇرچە)",
    zhMindmap: "دەرىس ئوي سىنبەلگىسى (خەنزۇچە)",
    ugMindmap: "دەرىس ئوي سىنبەلگىسى (ئۇيغۇرچە)",
    teacherLabel: "مۇئەللىم:",
    courseInfo: "دەرىس ئۇچۇرى",
    categoryName: "دەرىسنىڭ تۈرى",
    studyStatus: "ئۈگىنىش ئەھۋالى",
    batchOnShelf: "جازىغا چىقىرىش",
    batchOffShelf: "توختاپ تۇرۇش",
    batchSetCategory: "تۈر تەڭشەش",
    batchSelectWarning: "ئالدى بىلەن تاللاش كېرەك",
    selectCategoryWarning: "تۈرنى تاللاڭ",
    selectedCount: "%{count} دەرىس تاللاندى",
    teacher: {
      title: "مۇئەللىم تەڭشەش",
      name: "ئىسمى",
      ugName: "ئىسمى (ئۇيغۇرچە)",
      zhName: "ئىسمى (خەنزۇچە)",
      add: "مۇئەللىم قوشۇش",
      edit: "مۇئەللىم ئۆزگەرتىش",
      gender: "جىنىسى",
      male: "ئەر",
      female: "ئايال",
      ugDescription: "سۆزلۈگۈچى (ئۇيغۇرچە)",
      zhDescription: "سۆزلۈگۈچى (خەنزۇچە)",
    },
    category: {
      title: "تۈر تەڭشەش",
      name: "تۈرنىڭ ئىسمى",
      ugName: "تۈرنىڭ ئىسمى (ئۇيغۇرچە)",
      zhName: "تۈرنىڭ ئىسمى (خەنزۇچە)",
      add: "تۈر قوشۇش",
      edit: "تۈر تەڭشەش",
    },
    lesson: {
      title: "ۋاقىت تەڭشەش",
      name: "دەرىسنىڭ نامى",
      ugName: "دەرىسنىڭ نامى (ئۇيغۇرچە)",
      zhName: "دەرىسنىڭ نامى (خەنزۇچە)",
      add: "دەرىس قوشۇش",
      edit: "دەرىس تەڭشەش",
      duration: "دەرىس ۋاقتى",
      trial: "سىناپ كۆرۈش",
      trialDuration: "(سېكۇنت) سىناپ كۆرۈش ۋاقتى",
      lessonVideo: "دەرىس فىلىمى",
      lessonAudio: "دەرىس ئاۋازى",
    },
    student: {
      studyLevel: "ئۈگىنىپ نەگە كەلدى",
      add: "ئوقۇغۇچى قوشۇش",
      info: "ئوقۇغۇچى ئۇچۇرى",
      studyTime: "ئۈگىنىش ۋاقتى",
      studyProgress: "تاماملىنىشى",
      validTime: "ئىناۋەتلىك ۋاقىت",
      validForever: "ئۇزاققىچە ئىناۋەتلىك",
      customDate: "مۇددەت تاللاش",
      customDateLabel: "مۇددىتى",
    },
    comment: {
      title: "باھا باشقۇرۇش",
    },
    order: {
      title: "دەرىسلىك زاكاسلارنى باشقۇرۇش",
      customerInfo: "خېرىدار ئۇچۇرى",
      paidAt: "سېتىۋىلىنغان ۋاقتى",
      price: "سوممىسى",
      realPayment: "تۆلەنگەن پۇلى",
      detail: "زاكاس تەپسىلاتى",
      idLabel: "زاكاس نومۇرى: ",
      transactionIdLabel: "سودا نومۇرى: ",
      statusLabel: "زاكاس ھالىتى: ",
      createTimeLabel: "زاكاس چۈشۈرۈلگەن ۋاقتى: ",
      payTimeLabel: "پۇل تۆلەنگەن ۋاقتى: ",
      avatarLabel: "خېرىدار رەسىمى: ",
      nicknameLabel: "خېرىدار نامى: ",
      telLabel: "خېرىدارنىڭ تېلېفون نومۇرى: ",
      realPaymentLabel: "ھەقىقى تۆلەنگەن پۇلى: ",
      commissionInfoLabel: "تەۋسىيە ئۇچۇرى: ",
      commissionLabel: "تەۋسىيە قىلغۇچىنىڭ پايدىسى: ",
      parentCommissionLabel: "ئاتاسىنىڭ پايدىسى: ",
    },
    sliderAd: {
      title: "دەرىسلىك بېتىنىڭ سىيرىلما ئېلانى",
      add: "سىيرىلما ئېلانى قوشۇش",
      edit: "سىيرىلما ئېلانى تەڭشەش",
      name: "سىيرىلما ئېلانىنىڭ نامى",
    },
    album: {
      title: "دەرىس ئالبۇمى",
      add: "ئالبۇم قوشۇش",
      edit: "ئالبۇمنى تەھرىرلەش",
      name: "ئالبۇم نامى",
      category: "ئالبۇم تۈرى",
      price: "ئالبۇم باھاسى",
      marketPrice: "بازار نەرقى",
      originalPrice: "ئەسلى باھا",
      courses: "دەرىسلەر",
      selectCourses: "دەرىس تاللاش",
      coursesCount: "دەرىس سانى",
      batchOnShelf: "جازىغا چىقىرىش",
      batchOffShelf: "توختاپ تۇرۇش",
      batchSetCategory: "تۈر تەڭشەش",
      batchDelete: "ئۆچۈرۈش",
      selectedCount: "%{count} ئالبۇم تاللاندى",
      addCourses: "دەرىس قوشۇش",
      removeCourse: "دەرىسنى چىقىرىش",
      courseSelection: "دەرىس تاللاش",
      totalCoursesPrice: "دەرىسلەرنىڭ جەمئى باھاسى",
      albumPrice: "ئالبۇم باھاسى",
      discount: "ئېتىبار",
      validForever: "مەڭگۈلۈك ئىناۋەتلىك",
      validDays: "ئىناۋەتلىك كۈن سانى",
      status: "ھالەت",
      statusOnShelf: "جازىغا چىقىرىلغان",
      statusOffShelf: "توختاپ تۇرغان",
      sales: "سېتىلىشى",
      views: "كۆرۈلىشى",
      order: "تەرتىپى",
      cover: "مۇقاۋىسى",
      zhCover: "خەنزۇچە مۇقاۋىسى",
      ugCover: "ئۇيغۇرچە مۇقاۋىسى",
      description: "تەپسىلاتى",
      zhDescription: "خەنزۇچە تەپسىلاتى",
      ugDescription: "ئۇيغۇرچە تەپسىلاتى",
      basicInfo: "ئاساسىي ئۇچۇر",
      pricing: "باھا تەڭشەش",
      settings: "باشقا تەڭشەكلەر",
      courseManagement: "دەرىس باشقۇرۇش",
      noCourses: "دەرىس يوق",
      confirmRemoveCourse: "بۇ دەرىسنى چىقىرىمەن؟",
      selectCategoryWarning: "تۈرنى تاللاڭ",
      batchSelectWarning: "ئالدى بىلەن تاللاش كېرەك",
      cannotDeleteWithOrders: "بۇ ئالبۇمنىڭ زاكازى بار، ئۆچۈرۈشكە بولمايدۇ",
    },
  },
  link: {
    title: "ئۇلانما باشقۇرۇش",
    select: "تاللاش",
    deSelect: "بىكار قىلىش",
    platformLinks: "بەتلەر",
    selectedProductCategory: "%{category}~تاۋار تۈرى",
    selectedProduct: "%{product}~تاۋار",
    selectedCourseCategory: "%{category}~دەرىس تۈرى",
    selectedCourse: "%{course}~دەرىس",
    selected: "تاللانغان",
    products: "تاۋار تىزىملىكى",
    coursesCategories: "دەرىس تۈرى",
    courses: "دەرىسلىكلەر",
    courseAlbums: "دەرىس ئالبۇملىرى",
    weapp: "ئەپچاق ئۇلانمىسى",
    wechatAppId: "ئ‍ەپچاقنىڭ AppID سى",
    wechatPath: "ئەپچاقنىڭ بېتى",
    webview: "توربەت ئېلان",
    webviewUrl: "توربەت ئادرېسى",
  },
  link: {
    title: "ئۇلانما تاللىغۇچ",
    select: "تاللاش",
    deSelect: "تاللاشنى قالدۇرۇش",
    platformLinks: "ئەپچاق بەتلىرى",
    selectedProductCategory: "مال تۈرى~%{category}",
    selectedProduct: "مال~%{product}",
    selectedCourseCategory: "دەرس تۈرى~%{category}",
    selectedCourse: "دەرس~%{course}",
    selected: "تاللانغان",
    products: "مال تىزىملىكى",
    coursesCategories: "دەرس تۈرلىرى",
    courses: "دەرسلىك تىزىملىكى",
    weapp: "ئەپچاققا سەكرەش",
    wechatAppId: "ئەپچاقAPPID",
    wechatPath: "ئەپچاق ئۇلانمىسى",
  },
  qrcode: {
    type: "پائالىيەت شەكلى",
    activity: "پائالىيەت",
    title: "بىر مەھسۇلات بىر كود",
    listTitle: "تىزىملىك",
    name: "نامى",
    ugName: "نامى(ئۇيغۇرچە)",
    zhName: "نامى(خەنزۇچە)",
    batch: "تۈركۈم نومۇرى",
    quantity: "سانى",
    palletCapacity: "توپەن چوڭلىقى",
    cartoonCapacity: "چوڭ يەشىك چوڭلىقى",
    boxCapacity: "كىچىك يەشىك چوڭلىقى",
    qrcodeGenerateWarning:
      "ئىككىلىك كودنى ھاسىللامسىز، ھاسىللىغاندىن كېيىن باشقا ئۇچۇرلىرىنى ئۆزگەرتكىلى بولماي دۇ.",
    generateQRcode: "ھاسىللاش",
    excelGenerateWarning: "ھاسىللىغان كودلارنىڭExcelنى چىقىرامسىز？",
    generateExcel: "Excel ھاسىللاش",
    add: "يېڭى ئىككىلك كود",
    edit: "ئىككىلىك كود تەھرىرلەش",
    generatingQrcode: "ھاسىللىنىۋاتىدۇ",
    qrcodeDetailList: "تىزىملىكنى كۆرۈش",
    generatingExcel: "Excelھاسىللىنىۋاتىدۇ",
    downloadExcel: "Excelچۈشۈرۈش",
    prize: "مۇكاپات",
    type: "خاسلىقى",
    redPacketAmount: "سوممىسى",
    regionName: "رايون",
    scannedAt: "سىكانىرلىغان ۋاقتى",
    drawndAt: "مۇكاپات چىققان ۋاقىتى",
    exchangedAt: "نەقلەشتۈرگەن ۋاقتى",
    priority: "مۇھىملىقى",
    priorityRule: "سان قانچە يوقۇرى بولسا شۇنچە مۇھىم بولىدۇ",
    selectQrcode: "ئىككىلىك كود تاللاش",
    goToQrcodes: "ئىككىلىك كود باشقۇرۇش",
    selectRegion: "رايون تاللاش",
    regionRule:
      "ئەگەر مەلۇم رايوندا پائالىيەت قىلماقچى بولسىڭىز ،رايوننى تاللاڭ",
    redPacket: "قىزىل بولاق",
    redPacketWarning: "قىزىل بولاق سوممىسىنى تولدۇرۇڭ",
    productOnSite: "يەنە بىر مەھسۇلات",
    point: "جۇغلانما",
    redPaketWarning: "سوممىسىنى كىرگۈزۈڭ",
    pointWarning: "جۇغلانما نومۇرىنى كىرگۈزۈڭ",
    specialPrize: "بىۋاستە مۇكاپات چىقمايدۇ",
    expensePoints: "بىر قېتىملىق چەك تارتىشقا كېتىدىغان جۇغلانما نومۇرى",
    expensePointsRule: "پەقەت جۇغلانما ئارقىلىق مۇكاپات چىققاندىلا ئىشلەيدۇ",
    onHowManyTimes: "قانچىنجى قېتىم چەك تارتقاندا چىقىدۇ",
    customer: "خېرىدار تىپى",
    prize: "مۇكاپات شەكلى",
    client: "خېرىدار پائالىيىتى",
    shop: "دۇكان پائالىيىتى",
    prizeZero: "ھەر قېتىم چەك تارتىش",
    prizeOne: "بىرىنجى قېتىم چەك تارتىپ، ئارقىدىن جۇغلانما سوۋغا قىلىش",
    prizeTwo: "ھەر قېتىم جۇغلانما سوۋغا قىلىش",
    store: "دۇكان",
    signboard: "ۋىۋىسكا",
    businessLicense: "تىجارەت كىنىشكىسى",
    idCard: "كىملىك",
    applyDate: "ئىلتىماس ۋاقتى",
    approveDate: "تەستىق ۋاقتى",
    signboard: "ۋىۋىسكا",
    license: "تىجارەت كىنىشكىسى",
    idCard: "كىملىك",
    rejectReason: "رەت قىلىش سەۋەبى",
    agreement: "كېلىشىم",
    zhAgreement: "كېلىشىم (خەنزۇچە)",
    ugAgreement: "كېلىشىم (ئۇيغۇرچە)",
    typeCustomer: "خېرىدار كېلىشىمى",
    typeStore: "دۇكان كېلىشىمى",
    addAgreement: "كېلىشىم قوشۇش",
    redeemOrder: "نەقلەشتۈرۈش زاكازلىرى",
    transferToVip: "ۋاكالەتچىگە مال يۆتكەش",
    transferToVipSuccess: "مال يۆتكەش ئوڭۇشلۇق بولدى. %{count} مال تەۋە بولدى.",
    transferToVipError: "مال يۆتكەش مەغلۇپ بولدى.",
    transferBoxCode: "مال كودى / ئىككىلىك كود",
    transferBoxCodeRequired: "مال كودىنى كىرگۈزۈڭ",
    transferBoxCodePlaceholder: "سكان قىلىڭ ياكى كودنى كىرگۈزۈڭ",
    transferSelectVip: "ۋاكالەتچى تاللاش",
    transferSelectVipRequired: "ۋاكالەتچى تاللاڭ",
    transferSelectVipPlaceholder: "ۋاكالەتچى ئىزدەش ياكى تاللاش",
    transferSubmit: "يۆتكەش",
    code: "كود",
    typeFilterAll: "ھەممە تۈر",
    typeFilterBox: "قۇت",
    typeFilterProduct: "مەھسۇلات",
    filterByOwnership: "تەۋەلىك",
    ownershipAll: "ھەممىسى",
    ownershipOwned: "تەۋە بولدى",
    ownershipUnassigned: "تەۋە ئەمەس",
    userMobile: "ئىشلەتكۈچى يانفۇنى",
    itemCode: "تۈر كودى",
    vipUserItems: "ئىشلەتكۈچى تۈرلىرى",
    vipUserItemsSubtitle: "تۈركۈم ۋە قۇت بويىچە",
    totalBoxes: "قۇت سانى",
    totalProducts: "مەھسۇلات سانى",
    otherProductGroup: "باشقا مەھسۇلات",
  },
  tuangou: {
    shop: "دۇكان",
    location: "ئورنى",
    tuanzhang: "دۇكاندار",
    addShop: "دۇكان قوشۇش",
    address: "ئادرېس",
    coordinate: "كوردىناتى",
    latitude: "پارالېل",
    longitude: "مېردىئان",
    info: "چۈشەندۈرىلىشى",
    sliderAd: {
      title: "دۇكان بەت ئېلانى",
    },
  },
  recommender: {
    title: "ھەمكارلاشقۇچى",
    qrcode: "ئىككىلىك كود",
  },
  redPacketActivity: {
    title: "قىزىل بولاق",
    name: "پائالىيەت نامى",
    date: "پائالىيەت ۋاقتى",
    redPacket: "قىزىل بولاق",
    items: "تىزىملىك",
    generate: "ھاسىللاش",
    amount: "سوممىسى",
    amountDescription:
      "ئومومى سوممىسى 100مىڭدىن تۆۋەن بولىشى، 20 يۈەندىن كۆپ بولىشى كېرەك",
    average: "ھەر بىر كىشىگە ئوتتۇرا ھېساب بىلەن¥%{average} تارقىتىلىدۇ",
    min: "ئەز ئاز سوممىسى",
    max: "ئ‍ەڭ كۆپ سوممىسى",
    quantity: "سانى",
    type: "تۈرى",
    typeDescription:
      "ئەگەر خالىغانچە سوممىلىقنى تاللىسىڭىز، ھەر بىر كىشىنىڭ ئوخشىمايدىغان چىقىدۇ",
    typeSame: "ھەممىسى ئوخشاش",
    typeRandom: "خالىغانچە",
    receivedAt: "مۇكاپاتقا ئېرىشكەن ۋاقىت",
  },
  merchantStaff: {
    title: "خادىم باشقۇرۇش",
    add: "خادىم قوشۇش",
    edit: "خادىم تەھرىرلەش",
    name: "ئىسمى",
    mobile: "تېلېفون",
    status: "ھالىتى",
    statusActive: "قوزغىتىلغان",
    statusInactive: "توختىتىلغان",
    searchPlaceholder: "ئىسمى / تېلېفون",
    passwordHintCreate: "قۇرۇق قالسا سۈكۈتتىكى پارول 123456",
    passwordHintEdit: "قۇرۇق قالسا پارول ئۆزگەرمەيدۇ",
  },
  bd: {
    employee: {
      title: "بازار ئاچقۇچىلار",
      add: "بازار ئاچقۇچى قوشۇش",
      edit: "بازار ئاچقۇچى تەھرىرلەش",
    },
  },
  admin: {
    profitSharingReconciliation: {
      title: "پايدا ئايرىش كۈتۈش تەكشۈرۈش",
      description:
        "ئۈندىدار pending/available بىلەن زاكاز DB سوممىسىنى سېلىشتۇرۇپ، گۇمانلىق زاكازلارنى كۆرسىتىدۇ. پەقەت ئالىي باشقۇرغۇچى.",
      currentMerchant: "نۆۋەتتىكى دۇكان",
      refreshWechatBalance: "ئۈندىداردىن قايتا يېڭىlash",
      balanceRefreshed: "قالدۇق يېڭىلاندى",
      statsTitle: "پايدا ئايرىش ھېسابات ئستاتistikasi",
      balanceUpdatedAt: "ئۈندىدار قالدۇق يېڭىلangan ۋاقىت: %{time}",
      gapTitle: "pending بىلەن DB ئوخشاش ئەمەس",
      gapDescription:
        "real pending %{realPending} = WeChat %{pending} - in-progress DB %{inProgressDb}. residual %{residualGap} = pending - completed DB %{completedDb} - in-progress DB %{inProgressDb}. legacy gap %{legacyGap}.",
      orderIdFilter: "زاكاز ID",
      noIssues: "مەسىلە يوق",
      syncOrder: "ماسلاشتۇر",
      syncRefundedCleanup: "قايتۇرۇش تازىlash",
      requestFinish: "تاماملاش",
      refundRefunded: "قايتۇرۇلدى",
      refundInProgress: "قايتۇرۇۋاتىدۇ",
      finishRequiresCompleted: "Order not completed yet",
      bulkSync: {
        run: "Bulk sync",
        hint: "Upload WeChat delivery, refresh unsplit, submit sharing rounds for all orders in scope",
        confirmTitle: "Bulk sync profit-sharing orders",
        confirmDescription: "Sync %{count} orders in scope「%{scope}」one by one. Continue?",
        noOrders: "No orders to sync in current scope",
        clearOrderFilter: "Clear order ID filter before bulk sync",
        resultsTitle: "Bulk sync results",
        summary: "Total %{total}: %{success} ok, %{failed} failed",
        allSuccess: "Synced %{total} orders",
        partialSuccess: "Synced %{success}/%{total} orders — see failures",
        result: "Result",
        detail: "Detail",
        done: "Synced",
      },
      bulkFinish: {
        run: "Bulk request finish",
        hint: "Request WeChat profit-sharing finish for all orders in scope (same as single-row finish)",
        confirmTitle: "Bulk request finish",
        confirmDescription:
          "Request finish for %{count} orders in scope「%{scope}」one by one. Continue?",
        noOrders: "No orders to finish in current scope",
        clearOrderFilter: "Clear order ID filter before bulk finish",
        resultsTitle: "Bulk finish results",
        summary: "Total %{total}: %{success} ok, %{failed} failed",
        allSuccess: "Requested finish for %{total} orders",
        partialSuccess: "Finished %{success}/%{total} orders — see failures",
        result: "Result",
        detail: "Detail",
        done: "Finish requested",
      },
      scopes: {
        flagged: "flagged (completed)",
        pending: "DB pending > 0 (completed)",
        inProgress: "in progress",
        staleZero: "stale zero (180d, completed)",
        all: "all completed",
      },
      stats: {
        pendingWechat: "ئۈندىدار pending",
        realPending: "real pending",
        realPendingHint: "real pending = WeChat pending - in-progress DB sum. residual = pending - completed DB - in-progress DB.",
        availableWechat: "ئۈندىدار available",
        dbSumUnfinished: "DB جەمئىي",
        ordersPending: "pending زاكاز",
        nullUnfinished: "sync قilinmagan",
        staleZero: "stale zero",
        inProgressOrders: "in-progress PS orders",
        inProgressUnfinished: "in-progress DB sum",
        residualGap: "residual gap",
        pendingGap: "legacy pending gap",
      },
      columns: {
        orderId: "زاكاز ID",
        createdAt: "ۋاقىت",
        total: "سومما",
        unfinished: "تاماملانمagan",
        status: "ھالەت",
        refund: "قايتۇرۇش",
        issues: "مەسىلە",
        sharingRounds: "پايدا ئايرىش",
        recommended: "تەۋسىيە",
        actions: "مەشغۇلات",
      },
      actions: {
        syncFromWechat: "unsplit sync",
        syncRefundedCleanup: "refund cleanup",
        requestFinish: "finish",
        resolveSharingRounds: "round تامامla",
        inspectOrderDebug: "debug",
        none: "—",
      },
      issues: {
        dbUnsynced: "sync يوق",
        dbPending: "DB pending",
        refundedStaleUnfinished: "refund stale",
        sharingOpen: "sharing open",
        sharingMissing: "sharing missing",
        finishMissing: "finish missing",
        finishOpen: "finish open",
        finishBlocked: "finish blocked",
        orderInProgress: "in progress",
      },
      playbook: {
        title: "pending gap playbook",
        recommended: "recommended",
        intro: "WeChat pending > 0 but flagged/pending list empty: stale zero. Run artisan on server, then sync/finish here.",
        staleZeroHintTitle: "stale zero pattern",
        staleZeroHintDescription: "WeChat pending > 0, DB sum 0, empty list. Use CLI to query unsplit per transaction.",
        switchStaleZeroScope: "Switch to stale zero scope",
        switchedStaleZeroScope: "Switched to stale zero scope",
        steps: {
          confirm: {
            title: "1. Confirm gap",
            description: "Refresh WeChat balance above and confirm pending gap.",
          },
          find: {
            title: "2. Find unsplit txns (CLI)",
            description: "Run sum-unsplit-by-merchant; check unsplit > 0 and stale DB rows.",
            batchNote: "Large merchants: batch with txn-offset:",
          },
          syncDb: {
            title: "3. Sync DB from WeChat",
            description: "Run --sync-db; refresh page; pending orders should appear.",
          },
          finish: {
            title: "4. Finish sharing",
            description: "Complete rounds then request finish here or drop --no-finish in CLI.",
          },
          refund: {
            title: "5. Refund cleanup",
            description: "For refunded orders with stale unfinished, run sync-refunded-order.",
          },
          interpret: {
            title: "6. Interpret",
            match: "sum(unsplit) ≈ gap → sync DB and finish orders.",
            less: "sum(unsplit) < gap → older txns; use --all-time / txn batches.",
            zero: "sum(unsplit) = 0 but pending > 0 → orphan txn or non-order pending.",
          },
        },
      },
    },
    orderDebug: {
      title: "زاكاز سازلاش",
      description: "زاكاز نومۇرى بويىچە سازلاش ئۇچۇرىنى ئىزدەڭ (تۆلەش، پايدا ئايرىش، قايتۇرۇش قاتارلىق). پەقەت ئالىي باشقۇرغۇچىلا كىرەلەيدۇ.",
      orderIdPlaceholder: "زاكاز نومۇرىنى كىرگۈزۈڭ",
      enterOrderId: "زاكاز نومۇرىنى كىرگۈزۈڭ",
      invalidOrderId: "ئىناۋەتلىك زاكاز نومۇرىنى كىرگۈزۈڭ",
      fetchFailed: "ئۇچۇر ئېلىش مەغلۇپ بولدى",
      error: "خاتالىق",
      result: "سازلاش سانلىق مەلۇماتى",
      rawJson: "ئەسلى JSON",
      itemCount: "جەمئىي %{count} تۈر",
      sections: {
        order: "زاكاز ئۇچۇرى",
        wechatPay: "ئۈندىدار تۆلەش",
        combineOrderDetails: "بىرلەشتۈرۈلگەن تۆلەش تەپسىلاتى",
        refunds: "قايتۇرۇش خاتىرىسى",
        combineOrderRefundDetails: "بىرلەشتۈرۈلگەن قايتۇرۇش تەپسىلاتى",
        wechatProfitSharing: "ئۈندىدار پايدا ئايرىش",
        wechatProfitSharingFinish: "ئۈندىدار پايدا ئايرىش تامام",
        bulutBazarAgentCheckoutRecords: "ۋاكالەتچى دەلىللەش خاتىرىسى",
        bulutBazarMerchantCheckoutRecords: "دۇكان دەلىللەش خاتىرىسى",
        vipCommissions: "VIP پايدا",
        commissionWithdrawals: "پايدا چىقىم قىلىش",
        sharingPlan: "پايدا ئايرىش پىلانى",
        agentSharingDiagnostics: "ۋاكالەتچى پايدا / چىقىم تەكشۈرۈش",
        wechatSettlement: "ئۈندىدار مال يوللاش / ھېسابلاش",
      },
      syncWeChat: "ئۈندىدار مال يوللاش ۋە پايدا ئايرىشنى ماسلاشتۇر",
      syncSuccess: "ئۈندىدار مال يوللاندى، پايدا ئايرىش يېڭىلاندى",
      syncFailed: "ماسلاشتۇرۇش مەغلۇپ بولدى",
      wechatSettlementWaiting: "ئۈندىدار 48 سائەت ھېسابلاش كۈتۈش",
      wechatSettlementReady: "ئۈندىدار ھېسابلاش ۋاقتى ئۆتتى",
      wechatSettlementStatus: "ئۈندىدار مال يوللاش / ھېسابلاش ھالىتى",
      sharingDeferralReasons: "پايدا ئايرىش كېچىكتۈرۈلدى (ئۈندىدار تەييار ئەمەس)",
      agentSharingEligible: "commission withdrawal OK",
      agentSharingBlocked: "withdrawal blocked",
      agentSharingNotRequired: "WeChat agent sharing not required",
      recommendedCommand: "command",
      finishBlockers: "finish blockers",
      checklist: "checklist",
      checkPassed: "OK",
      checkFailed: "fail",
      agentSharingChecks: {
        profit_sharing_order: "profit sharing order",
        commission_rows_exist: "VIP commission rows",
        commission_status_eligible: "commission status",
        no_blocking_withdrawal: "no blocking withdrawal",
        withdraw_to_balance_disabled: "not balance withdraw",
        agent_transfer_on_accept: "transfer on accept",
        frozen_commission_early_sharing: "frozen / early share",
        frozen_commission_delivery_48h: "delivery 48h",
        frozen_commission_ok: "frozen OK",
        exceed_shareable_status: "exceed status",
        within_shareable_budget: "within budget",
        agent_round_prerequisites: "agent prerequisites",
        order_status_delivery: "delivery status",
        order_status_accept: "accept status",
        order_status_accept_transfer: "accept transfer",
        complete_order_after_days: "days after received",
        cron_60_day_window: "cron 60d window",
        agent_sharing_record: "agent sharing record",
        self_commission_settled_at_checkout: "self commission settled at checkout",
      },
      fields: {
        orderId: "زاكاز نومۇرى",
        order_no: "زاكاز كودى",
        price: "مەھسۇلات سوممىسى",
        ship_price: "توشۇش ھەققى",
        total: "جەمئىي",
        createdAt: "قۇرۇلغان ۋاقىت",
        merchantId: "دۇكان نومۇرى",
        merchantName: "دۇكان نامى",
        profitUnfinishedAmount: "تاماملانمىغان پايدا سوممىسى",
        level: "پايدا دەرىجىسى",
        level_label: "دەرىجە چۈشەندۈرۈشى",
        status: "ھالەت كودى",
        status_label: "ھالەت",
        isProfitSharingOrder: "پايدا ئايرىش زاكازىمۇ",
        isCombineOrder: "بىرلەشتۈرۈلگەن زاكازمۇ",
        received_at: "تاپشۇرۇۋالغان ۋاقىت",
        delivering_at: "يوللانغان ۋاقىت",
        merchantSettings: "دۇكان تەڭشىكى",
        uncheckoutCommissionTotal: "uncheckout total",
        maxAgentCommission: "agent max",
        agentRoundBlocker: "agent blocker",
        uploadDeliveryEnabled: "WeChat delivery upload",
        deliveringAt: "delivering at",
        settlementReady: "settlement ready",
        minutesUntilSettlementReady: "minutes until ready",
        settlementAt: "settlement at",
        awaitingWechatSettlement: "awaiting settlement",
        profitSharingRequestLocked: "sharing locked",
        profitSharingLockExpiresAt: "lock expires",
        sharingDeferralReasons: "deferral reasons",
        pendingSharingRows: "pending rounds",
        deliveryUploads: "delivery uploads",
        transactionId: "transaction id",
        context: "context",
        shippingSuccess: "shipping upload",
        confirmReceiveSuccess: "confirm receive",
        shippingErrcode: "shipping errcode",
        shippingErrmsg: "shipping errmsg",
        confirmErrcode: "confirm errcode",
        confirmErrmsg: "confirm errmsg",
        uploadedAt: "uploaded at",
        closeReason: "close reason",
        profitSharingOrderId: "profit sharing order id",
        outOrderNo: "out order no",
        shareAfterDelivery: "share after delivery",
        shareAfterAccept: "share after accept",
        enableWithdrawToBalance: "balance withdraw",
        agentTransferOnAccept: "transfer on accept",
        id: "نومۇر",
        order_id: "زاكاز نومۇرى",
        out_trade_no: "دۇكان زاكاز نومۇرى",
        transaction_id: "ئۈندىدار تۆلەش نومۇرى",
        prepay_id: "ئالدىن تۆلەش نومۇرى",
        trade_type: "سودا تۈرى",
        total_fee: "تۆلەش سوممىسى",
        number: "تەرتىپ نومۇرى",
        appid: "AppID",
        type: "تۈر",
        success_time: "تۆلەش مۇۋەپپەقىيەت ۋاقتى",
        sub_mchid: "تارماق دۇكان نومۇرى",
        merchant_id: "دۇكان نومۇرى",
        total_amount: "تۆلەش سوممىسى",
        merchant_name: "دۇكان نامى",
        total_price: "زاكاز سوممىسى",
        refund_price: "قايتۇرۇش سوممىسى",
        out_refund_no: "قايتۇرۇش نومۇرى",
        refund_id: "ئۈندىدار قايتۇرۇش نومۇرى",
        reason: "قايتۇرۇش سەۋەبى",
        failed_reason: "مەغلۇپ بولۇش سەۋەبى",
        finish_amount: "پايدا ئايرىش سوممىسى",
        close_reason: "تاقاش سەۋەبى",
        out_order_no: "پايدا ئايرىش نومۇرى",
        order_type: "زاكاز تۈرى",
        user_id: "ئىشلەتكۈچى نومۇرى",
        commission: "پايدا سوممىسى",
        commissionDetails: "پايدا تەپسىلاتى",
        commission_id: "پايدا نومۇرى",
        product_id: "مەھسۇلات نومۇرى",
        original_price: "ئەسلى باھا",
        amount: "سانى",
        commission_percent: "پايدا پىرسەنتى",
        profit_sharing_order_id: "ئۈندىدار پايدا نومۇرى",
        profit_sharing_type: "پايدا ئايرىش تۈرى",
        details: "پايدا ئايرىش تەپسىلاتى",
        wechat_profit_sharing_id: "پايدا ئايرىش نومۇرى",
        receiver_mchid: "قوبۇل قىلغۇچى دۇكان نومۇرى",
        fail_reason: "مەغلۇپ بولۇش سەۋەبى",
        description: "چۈشەندۈرۈش",
        coupon_id: "ئېتىبار كارتىسى نومۇرى",
        order_date: "زاكاز چېسىلىسى",
        product_price: "مەھسۇلات سوممىسى",
        product_price_payment_fee: "مەھسۇلات تۆلەش ھەققى",
        ship_price_payment_fee: "توشۇش تۆلەش ھەققى",
        packing_price: "قوراپ باھاسى",
        packing_price_payment_fee: "قوراپ تۆلەش ھەققى",
        platform_ratio: "سۇپا پىرسەنتى",
        deliver_by_us: "سۇپا توشۇش",
        payment_fee: "تۆلەش ھەققى",
        platform_income: "سۇپا كىرىمى",
        platform_expense: "سۇپا چىقىمى",
        merchant_income: "دۇكان كىرىمى",
        merchant_expense: "دۇكان چىقىمى",
        bb_agent_expense: "ۋاكالەتچى چىقىمى",
        bb_agent_income: "ۋاكالەتچى كىرىمى",
        v2Enabled: "V2 پايدا ئايرىش ئىقتىدارى",
        lastRoundType: "ئاخىرقى پايدا ئایرىش باسقۇچى",
        hasAgentCommission: "ۋاكالەتچى پايدىسى بار",
        hasSpecialShare: "ئالاھىدە پايدا ئايرىش بار",
        budget: "پايدا ئايرىش بۇدجېتى",
        rounds: "پايدا ئايرىش باسقۇچلىرى",
        legacyComparison: "كونا ئىقتىدار سېلىشتۇرۇش",
        required: "زۆرۈر",
        finish: "بۇ باسقۇچتا ئاخىرلاش",
        sharingStatus: "پايدا ئايرىش ھالىتى",
        sharingId: "پايدا ئايرىش خاتىرە ID",
        estimatedAmount: "مۆلچەرلەنگەن سومما",
        orderTotal: "زاكاز ئومۇمىي سومması",
        maxSharable: "ئۈندىدار ئەڭ چوڭ ئايرىش",
        safeMaxCommission: "بىخەتەر پايدا چېكى",
        paymentFee: "مۇلازىمەت ھەققى",
        specialShare: "ئالاھىدە پايدا ئايرىش",
        agentCommission: "ۋاكالەتچى پايدىسى",
        totalPlannedShare: "پىلانلانغان ئومۇمىي ئايرىش",
        remainingForMerchant: "دۇكان قالدۇقى",
        exceedsWechatLimit: "ئۈندىدار چېكىدىن ئېشىپ كەتتى",
        payment_fee: "مۇلازىمەت ھەققى",
        agent: "ۋاكالەتچى پايدىسى",
        special: "ئالاھىدە پايدا ئايرىش",
        paymentFeeWouldFinish: "كونا-مۇلازىمەت ھەققىدىن كېيىن ئاخىرلاش",
        agentWouldFinish: "كونا-ۋاكالەتچىدىن كېيىن ئاخىرلاش",
        specialWouldFinish: "كونا-ئالاھىدە پايدىدىن كېيىن ئاخىرلاش",
        created_at: "قۇرۇلغان ۋاقىت",
        updated_at: "يېڭىلانغان ۋاقىت",
        wechat_profit_sharing_detail_id: "پايدا ئايرىش تەپسىلات نومۇرى",
        merchant_expense_detail: "دۇكان چىقىم تەپسىلاتى",
        agent_expense_detail: "ۋاكالەتچى چىقىم تەپسىلاتى",
        platform_expense_detail: "سۇپا چىقىم تەپسىلاتى",
        status_change_log: "ھالەت ئۆزگەرۈش خاتىرىسى",
        status_history: "ھالەت تارىخى",
        combine_order_detail_id: "بىرلەشتۈرۈلگەن زاكاز تەپسىلات نومۇرى",
        agent_id: "ۋاكالەتچى نومۇرى",
        agent_snap: "ۋاكالەتچى سۈرەت",
      },
    },
  },
  video: {
    title: "فىلىم باشقۇرۇش",
    submenuVideos: "فىلىم تىزىملىكى",
    add: "فىلىم قوشۇش",
    edit: "فىلىم تەھرىرلەش",
    name: "فىلىم نامى",
    ugCover: "ئۇيغۇرچە مۇقاۋىسى",
    zhCover: "خەنزۇچە مۇقاۋىسى",
    videoFile: "فىلىم ھۆججىتى",
    duration: "ۋاقىت ئۇزۇنلۇقى",
    batchSelectWarning: "فىلىم تاللاڭ",
    selectedCount: "تاللانغان: %{count}",
    views: "كۆرۈلىشى",
    favorites: "يىغىلىشى",
    statistics: "ستاتىستىكا",
    defaultViews: "كۆرسىتىش نۆۋىتى",
    defaultFavourites: "يىغىش نۆۋىتى",
    notFound: "فىلىم تېپىلمىدى",
    fileName: "ھۆججەت نامى",
    fileSize: "ھۆججەت چوڭلۇقى",
    category: {
      title: "فىلىم تۈرى",
      name: "نامى",
      add: "تۈر قوشۇش",
      edit: "تۈر تەھرىرلەش",
    },
  },
  customPage: {
    title: "ئىختىيارى بەت",
    create: "بەت قۇرۇش",
    edit: "بەت تەھرىرلەش",
    pageType: "بەت تۈرى",
    pageTypeHome: "باش بەت",
    pageTypeUser: "ئىشلەتكۈچى بېتى",
    pageTypeVideoList: "فىلىم تىزىمى",
    language: "تىل",
    languageUyghur: "ئۇيغۇرچە",
    languageChinese: "خىتايچە",
    status: "ھالەت",
    statusDraft: "قۇرۇق",
    statusPublished: "ئېلان قىلىنغان",
    version: "نەشرى",
    publishedAt: "ئېلان قىلىنغان ۋاقىت",
    duplicate: "كۆچۈرۈش",
    publish: "ئېلان قىلىش",
    saveDraft: "قۇرۇق ساقلاش",
    saveSuccess: "مۇۋەپپەقىيەتلىك ساقلاندى",
    publishSuccess: "مۇۋەپپەقىيەتلىك ئېلان قىلىندى",
    duplicateSuccess: "مۇۋەپپەقىيەتلىك كۆچۈرۈلدى",
    saveBeforePublish: "ئاۋۋال قۇرۇق ساقلاڭ",
    publishConfirm: "ئېلان قىلىشنى جەزملەش",
    publishConfirmMessage: "ئېلان قىلغاندىن كېيىن بەت ئىشلەتكۈچىلەرگە كۆرۈنىدۇ، ئېلان قىلىشنى خالامسىز؟",
    blocks: "بۆلەك تىزىمى",
    blockPalette: "بۆلەك پالتا",
    blockSettings: "بۆلەك تەڭشىكى",
    selectBlockToEdit: "تەھرىرلەش ئۈچۈن بۆلەك تاللاڭ",
    noBlocks: "بۆلەك يوق",
    noBlocksPreview: "بۆلەك يوق، بۆلەك قوشۇڭ",
    blockTypeBanner: "سۈرەت سىزىقى",
    blockTypeProductGrid: "مەھسۇلات تورى",
    blockTypeCategoryGrid: "كاتېگورىيە تورى",
    blockTypeNavigation: "يۆتكىلىش",
    blockTypeVideo: "فىلىم",
    blockTypeAdvertisement: "ئېلان",
    blockTypeText: "تېكىست",
    blockTypeFlashSale: "چەكلىمىلىك سېتىش",
    bannerItems: "سۈرەت سىزىقى تۈرى",
    image: "سۈرەت",
    imageUyghur: "ئۇيغۇرچە سۈرەت",
    imageChinese: "خىتايچە سۈرەت",
    linkType: "ئۇلاش تۈرى",
    linkTypeNone: "ئۇلاش يوق",
    linkTypeProduct: "مەھسۇلات",
    linkTypeCategory: "كاتېگورىيە",
    linkTypeUrl: "تور ئادرېسى",
    linkTypePage: "بەت",
    link: "ئۇلاش",
    autoplay: "ئۆزلۈكىدىن قويۇش",
    interval: "ئارىلىق (مىللىسېكۇنت)",
    height: "ئېگىزلىكى",
    titleUyghur: "ئۇيغۇرچە ماۋزۇ",
    titleChinese: "خىتايچە ماۋزۇ",
    source: "مەنبە",
    sourceCategory: "كاتېگورىيە",
    sourceFeatured: "تاللانغان",
    sourceDiscounted: "ئېتىش",
    sourceCustom: "ئىختىيارى",
    sourceLatest: "ئەڭ يېڭى",
    categoryId: "كاتېگورىيە ID",
    categoryIds: "كاتېگورىيە ID لار",
    productIds: "مەھسۇلات ID لار",
    videoIds: "فىلىم ID لار",
    columns: "ستون سانى",
    limit: "سان چەكلىمىسى",
    showPrice: "باھا كۆرسىتىش",
    navigationIcons: "يۆتكىلىش سىنبەلگىسى",
    icon: "سىنبەلگە",
    addBannerItem: "سۈرەت سىزىقى تۈرى قوشۇش",
    addNavigationIcon: "يۆتكىلىش سىنبەلگىسى قوشۇش",
    layout: "جايلاشتۇرۇش",
    layoutGrid: "تور",
    layoutList: "تىزىم",
    content: "مەزمۇن",
    name: "ئىسمى",
    backgroundColor: "ئارقا رەڭ",
    padding: "ئىچكى بوشلۇق",
    flashSaleId: "چەكلىمىلىك سېتىش ID",
    showCountdown: "سانىش كۆرسىتىش",
    errorMaxBlocks: "ئەڭ كۆپ 30 بۆلەك قوشۇشقا بولىدۇ",
    errorMaxBanners: "ئەڭ كۆپ 5 سۈرەت سىزىقى بۆلىكى قوشۇشقا بولىدۇ",
    errorMaxProductGrids: "ئەڭ كۆپ 10 مەھسۇلات تور بۆلىكى قوشۇشقا بولىدۇ",
    errorMaxNavigationBlocks: "ئەڭ كۆپ 1 يۆتكىلىش بۆلىكى قوشۇشقا بولىدۇ",
    errorMaxVideoSections: "ئەڭ كۆپ 2 فىلىم بۆلىكى قوشۇشقا بولىدۇ",
  },
  groupon: {
    title: "گۇرۇپپا سودا",
    deals: "تۈر باشقۇرۇش",
    orders: "زاكاز باشقۇرۇش",
    addDeal: "تۈر قوشۇش",
    editDeal: "تۈر تەھرىرلەش",
    deal: "تۈر",
    originalPrice: "ئەسلى باھا (يۈەن)",
    salePrice: "سېتىش باھا (يۈەن)",
    neededPoints: "كېرەكلىك جۇغلانما",
    neededPointsRequired: "جۇغلانما سانىنى كىرگۈزۈڭ",
    validDays: "كۈن سانى",
    includedItems: "ئىچكى تۈرلەر",
    addItem: "تۈر قوشۇش",
    itemMarketPrice: "بازار باھا (يۈەن)",
    itemQuantity: "سانى",
    points: "جۇغلانما",
    cash: "نەق پۇل",
    verify: "ئىشلىتىش",
    verified: "ئىشلىتىلدى",
    refund: "قايتۇرۇش",
    refunded: "قايتۇرۇلدى",
    enterToken: "ئىشلىتىش كودى",
    redeemToken: "ئىشلىتىش كودى",
    expiresAt: "ۋاقتى",
    statusPending: "پۇل تۆلەش كۈتۈۋاتىدۇ",
    statusPaid: "ئىشلىتىشكە تەييار",
    statusRedeemed: "ئىشلىتىلدى",
    statusRefunded: "قايتۇرۇلدى",
    statusLabel: {
      0: "پۇل تۆلەش كۈتۈۋاتىدۇ",
      1: "ئىشلىتىشكە تەييار",
      2: "ئىشلىتىلدى",
      3: "قايتۇرۇلدى",
      4: "بىكار قىلىندى",
    },
    zhName: "خەنزۇچە نام",
    ugName: "ئۇيغۇرچە نام",
    zhDescription: "خەنزۇچە چۈشەندۈرۈش",
    ugDescription: "ئۇيغۇرچە چۈشەندۈرۈش",
    sortOrder: "تەرتىپ",
    edit: "تەھرىرلەش",
    delete: "ئۆچۈرۈش",
    save: "ساقلاش",
    cancel: "بىكار قىلىش",
    back: "قايتىش",
    detail: "تەپسىلات",
    all: "ھەممىسى",
    search: "ئىزدەش",
    active: "ئېچىق",
  },
  task: {
    add: "ۋەزىپە قوشۇش",
    edit: "ۋەزىپە تەھرىرلەش",
    trigger: "قوزغىتىش شەرتى",
    triggerFirstPaidOrder: "تۇنجى پۇل تۆلىگەن زاكاز",
    triggerUploadAvatar: "باش سۈرەت يوللاش",
    triggerUpdateNickname: "ئىسىم ئۆزگەرتىش",
    visibility: "كۆرۈنۈش شەكلى",
    visibilitySilent: "يوشۇرۇن (ئاپتوماتىك)",
    visibilityVisible: "ۋەزىپە مەركىزىدە كۆرۈنىدۇ",
    visibilityHint:
      "يوشۇرۇن ۋەزىپە مەركەزدە كۆرۈنمەيدۇ، ھادىسە يۈز بەرگەندە ئاپتوماتىك تاماملانۇپ مۇكاپات بېرىلىدۇ؛ كۆرۈنىدىغان ۋەزىپە ئۈچۈن ئىشلەتكۈچى ئالدى بىلەن ئېلىشى، تاماملىغاندىن كېيىن مۇكاپات ئېلىشى كېرەك.",
    memberCard: "ئەزالىق كارتا مۇكاپاتى",
    memberCardPlaceholder: "ئەزالىق كارتا تاللاڭ (ئىختىيارىي)",
    coupons: "ئېتىبار كارتا مۇكاپاتى",
    couponsPlaceholder: "ئېتىبار كارتا تاللاڭ (كۆپ تاللاش)",
    rewardRequired: "ئەزالىق كارتا ياكى ئېتىبار كارتىدىن كەمىدە بىرنى تاللاڭ",
    nameRequired: "ۋەزىپە نامىنى تولدۇرۇڭ",
    status: "ھالىتى",
    enabled: "قوزغىتىلغان",
    disabled: "توختىتىلغان",
    sort: "تەرتىپ",
  },
  storeMembership: {
    enableHint: "ئالدى بىلەن دۇكان تەڭشىكىدە «پۈتۈن سېتىش دۇكان تەكشۈرۈشى» نى ئېچىڭ",
    storeName: "دۇكان نامى",
    user: "ئىشلەتكۈچى",
    address: "ئادرېس",
    storefront: "دۇكان ئالدى رەسىم",
    license: "تىجارەت كىنىشكىسى",
    status: "ھالىتى",
    status_pending: "تەكشۈرۈشتە",
    status_approved: "تەستىقلانغان",
    status_rejected: "رەت قىلىنغان",
    status_banned: "چەكلەنگەن",
    status_all: "ھەممىسى",
    actions: "مەشغۇلات",
    approve: "تەستىقلاش",
    reject: "رەت قىلىش",
    ban: "چەكلەش",
    unban: "چەكلەشنى ئېلىش",
    edit: "تەھرىرلەش",
    delete: "ئۆچۈرۈش",
    deleteConfirm: "بۇ دۇكان تەكشۈرۈشىنى ئۆچۈرەمسىز؟ ئۆچۈرگەندىن كېيىن خېرىدار قايتا يوللىشى كېرەك.",
    upload: "يوللاش",
    show: "كۆرۈش",
    detailTitle: "دۇكان تەكشۈرۈش تەپسىلاتى",
    close: "تاقاش",
    location: "ئورۇن",
    noLocation: "كوئوردىنات يوق",
    search: "ئىزدەش",
    searchPlaceholder: "دۇكان نامى / تېلېفون / ئادرېس",
    totalCount: "جەمئىي %{count}",
    approved: "تەستىقلاندى",
    rejected: "رەت قىلىندى",
    banned: "چەكلەندى",
    updated: "يېڭىلاندى",
    deleted: "ئۆچۈرۈلدى",
    rejectReason: "رەت قىلىش سەۋەبى (ئىختىيارىي)",
    banReason: "چەكلەش سەۋەبى (خېرىدارغا كۆرسىتىلىدۇ)",
    banReasonRequired: "چەكلەش سەۋەبىنى تولدۇرۇڭ",
    storeNameRequired: "دۇكان نامىنى تولدۇرۇڭ",
    storefrontRequired: "دۇكان ئالدى رەسىمىنى يوللاڭ",
    attribution: "خېرىدار تەۋەلىكى",
    attributionAll: "ھەممە تەۋەلىك",
    unassigned: "تەقسىملەنمىگەن",
    attributionStatsTitle: "خېرىدار تەۋەلىك ئىستاتىستىكا",
    viewList: "تىزىملىكنى كۆرۈش",
    refresh: "يېڭىلاش",
  },
};
